import { n as e, t } from "./rolldown-runtime-CbXtAM7H.js";
var n = t(e => {
  var t = Symbol.for(`react.transitional.element`);
  var n = Symbol.for(`react.portal`);
  var r = Symbol.for(`react.fragment`);
  var i = Symbol.for(`react.strict_mode`);
  var a = Symbol.for(`react.profiler`);
  var o = Symbol.for(`react.consumer`);
  var s = Symbol.for(`react.context`);
  var c = Symbol.for(`react.forward_ref`);
  var l = Symbol.for(`react.suspense`);
  var u = Symbol.for(`react.memo`);
  var d = Symbol.for(`react.lazy`);
  var f = Symbol.for(`react.activity`);
  var p = Symbol.for(`react.view_transition`);
  var ee = Symbol.iterator;
  function m(e) {
    if (typeof e != `object` || !e) {
      return null;
    } else {
      e = ee && e[ee] || e[`@@iterator`];
      if (typeof e == `function`) {
        return e;
      } else {
        return null;
      }
    }
  }
  var h = {
    isMounted: function () {
      return false;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {}
  };
  var te = Object.assign;
  var g = {};
  function _(e, t, n) {
    this.props = e;
    this.context = t;
    this.refs = g;
    this.updater = n || h;
  }
  _.prototype.isReactComponent = {};
  _.prototype.setState = function (e, t) {
    if (typeof e != `object` && typeof e != `function` && e != null) {
      throw Error(`takes an object of state variables to update or a function which returns an object of state variables.`);
    }
    this.updater.enqueueSetState(this, e, t, `setState`);
  };
  _.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, `forceUpdate`);
  };
  function v() {}
  v.prototype = _.prototype;
  function y(e, t, n) {
    this.props = e;
    this.context = t;
    this.refs = g;
    this.updater = n || h;
  }
  var b = y.prototype = new v();
  b.constructor = y;
  te(b, _.prototype);
  b.isPureReactComponent = true;
  var x = Array.isArray;
  function S() {}
  var C = {
    H: null,
    A: null,
    T: null,
    S: null
  };
  var w = Object.prototype.hasOwnProperty;
  function T(e, n, r) {
    var i = r.ref;
    return {
      $$typeof: t,
      type: e,
      key: n,
      ref: i === undefined ? null : i,
      props: r
    };
  }
  function E(e, t) {
    return T(e.type, t, e.props);
  }
  function D(e) {
    return typeof e == `object` && !!e && e.$$typeof === t;
  }
  function O(e) {
    var t = {
      "=": `=0`,
      ":": `=2`
    };
    return `$${e.replace(/[=:]/g, function (e) {
      return t[e];
    })}`;
  }
  var k = /\/+/g;
  function ne(e, t) {
    if (typeof e == `object` && e && e.key != null) {
      return O(`${e.key}`);
    } else {
      return t.toString(36);
    }
  }
  function re(e) {
    switch (e.status) {
      case `fulfilled`:
        return e.value;
      case `rejected`:
        throw e.reason;
      default:
        if (typeof e.status == `string`) {
          e.then(S, S);
        } else {
          e.status = `pending`;
          e.then(function (t) {
            if (e.status === `pending`) {
              e.status = `fulfilled`;
              e.value = t;
            }
          }, function (t) {
            if (e.status === `pending`) {
              e.status = `rejected`;
              e.reason = t;
            }
          });
        }
        switch (e.status) {
          case `fulfilled`:
            return e.value;
          case `rejected`:
            throw e.reason;
        }
    }
    throw e;
  }
  function A(e, r, i, a, o) {
    var s = typeof e;
    if (s === `undefined` || s === `boolean`) {
      e = null;
    }
    var c = false;
    if (e === null) {
      c = true;
    } else {
      switch (s) {
        case `bigint`:
        case `string`:
        case `number`:
          c = true;
          break;
        case `object`:
          switch (e.$$typeof) {
            case t:
            case n:
              c = true;
              break;
            case d:
              c = e._init;
              return A(c(e._payload), r, i, a, o);
          }
      }
    }
    if (c) {
      o = o(e);
      c = a === `` ? `.${ne(e, 0)}` : a;
      if (x(o)) {
        i = ``;
        if (c != null) {
          i = `${c.replace(k, `$&/`)}/`;
        }
        A(o, r, i, ``, function (e) {
          return e;
        });
      } else if (o != null) {
        if (D(o)) {
          o = E(o, i + (o.key == null || e && e.key === o.key ? `` : `${`${o.key}`.replace(k, `$&/`)}/`) + c);
        }
        r.push(o);
      }
      return 1;
    }
    c = 0;
    var l = a === `` ? `.` : `${a}:`;
    if (x(e)) {
      for (var u = 0; u < e.length; u++) {
        a = e[u];
        s = l + ne(a, u);
        c += A(a, r, i, s, o);
      }
    } else {
      u = m(e);
      if (typeof u == `function`) {
        e = u.call(e);
        u = 0;
        while (!(a = e.next()).done) {
          a = a.value;
          s = l + ne(a, u++);
          c += A(a, r, i, s, o);
        }
      } else if (s === `object`) {
        if (typeof e.then == `function`) {
          return A(re(e), r, i, a, o);
        }
        r = String(e);
        throw Error(`Objects are not valid as a React child (found: ${r === `[object Object]` ? `object with keys {${Object.keys(e).join(`, `)}}` : r}). If you meant to render a collection of children, use an array instead.`);
      }
    }
    return c;
  }
  function j(e, t, n) {
    if (e == null) {
      return e;
    }
    var r = [];
    var i = 0;
    A(e, r, ``, ``, function (e) {
      return t.call(n, e, i++);
    });
    return r;
  }
  function ie(e) {
    if (e._status === -1) {
      var t = e._result;
      var n = t();
      n.then(function (t) {
        if (e._status === 0 || e._status === -1) {
          e._status = 1;
          e._result = t;
          if (n.status === undefined) {
            n.status = `fulfilled`;
            n.value = t;
          }
        }
      }, function (t) {
        if (e._status === 0 || e._status === -1) {
          e._status = 2;
          e._result = t;
          if (n.status === undefined) {
            n.status = `rejected`;
            n.reason = t;
          }
        }
      });
      if (e._status === -1) {
        e._status = 0;
        e._result = n;
      }
    }
    if (e._status === 1) {
      return e._result.default;
    }
    throw e._result;
  }
  var M = typeof reportError == `function` ? reportError : function (e) {
    if (typeof window == `object` && typeof window.ErrorEvent == `function`) {
      var t = new window.ErrorEvent(`error`, {
        bubbles: true,
        cancelable: true,
        message: typeof e == `object` && e && typeof e.message == `string` ? String(e.message) : String(e),
        error: e
      });
      if (!window.dispatchEvent(t)) {
        return;
      }
    } else if (typeof process == `object` && typeof process.emit == `function`) {
      process.emit(`uncaughtException`, e);
      return;
    }
    console.error(e);
  };
  function ae(e) {
    var t = C.T;
    var n = {
      types: t === null ? null : t.types
    };
    C.T = n;
    try {
      var r = e();
      var i = C.S;
      if (i !== null) {
        i(n, r);
      }
      if (typeof r == `object` && r && typeof r.then == `function`) {
        r.then(S, M);
      }
    } catch (e) {
      M(e);
    } finally {
      if (t !== null && n.types !== null) {
        t.types = n.types;
      }
      C.T = t;
    }
  }
  function oe(e) {
    var t = C.T;
    if (t !== null) {
      var n = t.types;
      if (n === null) {
        t.types = [e];
      } else if (n.indexOf(e) === -1) {
        n.push(e);
      }
    } else {
      ae(oe.bind(null, e));
    }
  }
  var se = {
    map: j,
    forEach: function (e, t, n) {
      j(e, function () {
        t.apply(this, arguments);
      }, n);
    },
    count: function (e) {
      var t = 0;
      j(e, function () {
        t++;
      });
      return t;
    },
    toArray: function (e) {
      return j(e, function (e) {
        return e;
      }) || [];
    },
    only: function (e) {
      if (!D(e)) {
        throw Error(`React.Children.only expected to receive a single React element child.`);
      }
      return e;
    }
  };
  e.Activity = f;
  e.Children = se;
  e.Component = _;
  e.Fragment = r;
  e.Profiler = a;
  e.PureComponent = y;
  e.StrictMode = i;
  e.Suspense = l;
  e.ViewTransition = p;
  e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = C;
  e.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function (e) {
      return C.H.useMemoCache(e);
    }
  };
  e.addTransitionType = oe;
  e.cache = function (e) {
    return function () {
      return e.apply(null, arguments);
    };
  };
  e.cacheSignal = function () {
    return null;
  };
  e.cloneElement = function (e, t, n) {
    if (e == null) {
      throw Error(`The argument must be a React element, but you passed ${e}.`);
    }
    var r = te({}, e.props);
    var i = e.key;
    if (t != null) {
      if (t.key !== undefined) {
        i = `${t.key}`;
      }
      for (a in t) {
        if (!!w.call(t, a) && a !== `key` && a !== `__self` && a !== `__source` && (a !== `ref` || t.ref !== undefined)) {
          r[a] = t[a];
        }
      }
    }
    var a = arguments.length - 2;
    if (a === 1) {
      r.children = n;
    } else if (a > 1) {
      var o = Array(a);
      for (var s = 0; s < a; s++) {
        o[s] = arguments[s + 2];
      }
      r.children = o;
    }
    return T(e.type, i, r);
  };
  e.createContext = function (e) {
    e = {
      $$typeof: s,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    };
    e.Provider = e;
    e.Consumer = {
      $$typeof: o,
      _context: e
    };
    return e;
  };
  e.createElement = function (e, t, n) {
    var r;
    var i = {};
    var a = null;
    if (t != null) {
      if (t.key !== undefined) {
        a = `${t.key}`;
      }
      for (r in t) {
        if (w.call(t, r) && r !== `key` && r !== `__self` && r !== `__source`) {
          i[r] = t[r];
        }
      }
    }
    var o = arguments.length - 2;
    if (o === 1) {
      i.children = n;
    } else if (o > 1) {
      var s = Array(o);
      for (var c = 0; c < o; c++) {
        s[c] = arguments[c + 2];
      }
      i.children = s;
    }
    if (e && e.defaultProps) {
      o = e.defaultProps;
      for (r in o) {
        if (i[r] === undefined) {
          i[r] = o[r];
        }
      }
    }
    return T(e, a, i);
  };
  e.createRef = function () {
    return {
      current: null
    };
  };
  e.forwardRef = function (e) {
    return {
      $$typeof: c,
      render: e
    };
  };
  e.isValidElement = D;
  e.lazy = function (e) {
    return {
      $$typeof: d,
      _payload: {
        _status: -1,
        _result: e
      },
      _init: ie
    };
  };
  e.memo = function (e, t) {
    return {
      $$typeof: u,
      type: e,
      compare: t === undefined ? null : t
    };
  };
  e.startTransition = ae;
  e.unstable_useCacheRefresh = function () {
    return C.H.useCacheRefresh();
  };
  e.use = function (e) {
    return C.H.use(e);
  };
  e.useActionState = function (e, t, n) {
    return C.H.useActionState(e, t, n);
  };
  e.useCallback = function (e, t) {
    return C.H.useCallback(e, t);
  };
  e.useContext = function (e) {
    return C.H.useContext(e);
  };
  e.useDebugValue = function () {};
  e.useDeferredValue = function (e, t) {
    return C.H.useDeferredValue(e, t);
  };
  e.useEffect = function (e, t) {
    return C.H.useEffect(e, t);
  };
  e.useEffectEvent = function (e) {
    return C.H.useEffectEvent(e);
  };
  e.useId = function () {
    return C.H.useId();
  };
  e.useImperativeHandle = function (e, t, n) {
    return C.H.useImperativeHandle(e, t, n);
  };
  e.useInsertionEffect = function (e, t) {
    return C.H.useInsertionEffect(e, t);
  };
  e.useLayoutEffect = function (e, t) {
    return C.H.useLayoutEffect(e, t);
  };
  e.useMemo = function (e, t) {
    return C.H.useMemo(e, t);
  };
  e.useOptimistic = function (e, t) {
    return C.H.useOptimistic(e, t);
  };
  e.useReducer = function (e, t, n) {
    return C.H.useReducer(e, t, n);
  };
  e.useRef = function (e) {
    return C.H.useRef(e);
  };
  e.useState = function (e) {
    return C.H.useState(e);
  };
  e.useSyncExternalStore = function (e, t, n) {
    return C.H.useSyncExternalStore(e, t, n);
  };
  e.useTransition = function () {
    return C.H.useTransition();
  };
  e.version = `19.3.0`;
});
var r = t((e, t) => {
  t.exports = n();
});
var i = e(r(), 1);
var a = e => e.type === `checkbox`;
var o = e => e.type === `file`;
var s = e => e instanceof Date;
var c = e => e == null;
var l = e => typeof e == `object`;
var u = e => !c(e) && !Array.isArray(e) && l(e) && !s(e);
var d = e => u(e) && e.target ? a(e.target) ? e.target.checked : o(e.target) ? e.target.files : e.target.value : e;
var f = /[.[\]'"]/;
var p = e => e.split(f).filter(Boolean);
var ee = (e, t) => t.split(`.`).some((t, n, r) => !isNaN(Number(t)) && e.has(r.slice(0, n).join(`.`)));
var m = typeof window < `u` && window.HTMLElement !== undefined && typeof document < `u`;
function h(e) {
  if (typeof e != `object` || !e) {
    return e;
  }
  if (e instanceof Date) {
    return new Date(e);
  }
  let t = typeof Blob < `u` && e instanceof Blob;
  let n = typeof FileList < `u` && e instanceof FileList;
  if (m && (t || n)) {
    return e;
  }
  let r = Array.isArray(e);
  if (!r && e.constructor !== Object) {
    return e;
  }
  let i = r ? [] : Object.create(Object.getPrototypeOf(e));
  for (let t in e) {
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      i[t] = h(e[t]);
    }
  }
  return i;
}
var te = {
  BLUR: `blur`,
  FOCUS_OUT: `focusout`,
  CHANGE: `change`,
  SUBMIT: `submit`,
  TRIGGER: `trigger`,
  VALID: `valid`
};
var g = {
  onBlur: `onBlur`,
  onChange: `onChange`,
  onSubmit: `onSubmit`,
  onTouched: `onTouched`,
  all: `all`
};
var _ = {
  max: `max`,
  min: `min`,
  maxLength: `maxLength`,
  minLength: `minLength`,
  pattern: `pattern`,
  required: `required`,
  validate: `validate`
};
var v = `root`;
var y = [`__proto__`, `constructor`, `prototype`];
var b = /^\w*$/;
var x = e => b.test(e);
var S = e => e === undefined;
var C = (e, t, n) => {
  if (!t || !u(e)) {
    return n;
  }
  let r = x(t) ? [t] : p(t);
  if (r.some(e => y.includes(e))) {
    return n;
  }
  let i = r.reduce((e, t) => c(e) ? undefined : e[t], e);
  if (S(i) || i === e) {
    if (S(e[t])) {
      return n;
    } else {
      return e[t];
    }
  } else {
    return i;
  }
};
var w = e => typeof e == `boolean`;
var T = e => typeof e == `function`;
var E = (e, t, n) => {
  let r = -1;
  let i = x(t) ? [t] : p(t);
  let a = i.length;
  let o = a - 1;
  while (++r < a) {
    let t = i[r];
    let a = n;
    if (r !== o) {
      let n = e[t];
      a = u(n) || Array.isArray(n) ? n : isNaN(+i[r + 1]) ? {} : [];
    }
    if (y.includes(t)) {
      return;
    }
    e[t] = a;
    e = e[t];
  }
};
var D = i.createContext(null);
D.displayName = `HookFormControlContext`;
var O = (e, t, n, r = true) => {
  let i = {};
  for (let a in e) {
    Object.defineProperty(i, a, {
      get: () => {
        let i = a;
        if (t._proxyFormState[i] !== g.all) {
          t._proxyFormState[i] = !r || g.all;
        }
        if (n) {
          n[i] = true;
        }
        return e[i];
      }
    });
  }
  return i;
};
var k = m ? i.useLayoutEffect : i.useEffect;
var ne = e => {
  let t = e.constructor && e.constructor.prototype;
  return u(t) && t.hasOwnProperty(`isPrototypeOf`);
};
var re = e => c(e) || !l(e);
var A = (e, t) => t.length === 0 && !Array.isArray(e) && !ne(e);
function j(e, t, n = new WeakMap()) {
  if (e === t) {
    return true;
  }
  if (re(e) || re(t)) {
    return Object.is(e, t);
  }
  if (s(e) && s(t)) {
    return Object.is(e.getTime(), t.getTime());
  }
  let r = Object.keys(e);
  let i = Object.keys(t);
  if (r.length !== i.length) {
    return false;
  }
  if (A(e, r) || A(t, i)) {
    return Object.is(e, t);
  }
  if (!r.length && Array.isArray(e) !== Array.isArray(t)) {
    return false;
  }
  let a = n.get(e);
  if (a && a.has(t)) {
    return true;
  }
  if (a) {
    a.add(t);
  } else {
    let r = new WeakSet();
    r.add(t);
    n.set(e, r);
  }
  for (let i of r) {
    let r = e[i];
    if (!(i in t)) {
      return false;
    }
    if (i !== `ref`) {
      let e = t[i];
      if (s(r) && s(e) || (u(r) || Array.isArray(r)) && (u(e) || Array.isArray(e)) ? !j(r, e, n) : !Object.is(r, e)) {
        return false;
      }
    }
  }
  return true;
}
function ie(e) {
  let t = i.useRef(false);
  let n = i.useRef(false);
  let r = i.useRef(undefined);
  let a = i.useRef(0);
  a.current++;
  if (!n.current && e) {
    n.current = true;
    r.current = h(e());
  }
  return {
    resyncIfNeeded: i.useCallback((e, i, o) => {
      if (e && (t.current || n.current && a.current > 1)) {
        let e = i();
        if (!j(r.current, e)) {
          o(e);
        }
      }
      t.current = true;
    }, []),
    snapshot: i.useCallback((e, t) => {
      if (e) {
        r.current = h(t());
      }
    }, [])
  };
}
var M = e => typeof e == `string`;
var ae = (e, t, n, r, i) => M(e) ? (r && t.watch.add(e), C(n, e, i)) : Array.isArray(e) ? e.map(e => {
  if (r) {
    t.watch.add(e);
  }
  return C(n, e, C(i, e));
}) : (r && (t.watchAll = true), n);
var oe = e => ({
  isOnSubmit: !e || e === g.onSubmit,
  isOnBlur: e === g.onBlur,
  isOnChange: e === g.onChange,
  isOnAll: e === g.all,
  isOnTouch: e === g.onTouched
});
var se = (e, t, n) => {
  if (n) {
    return false;
  }
  if (t.watchAll || t.watch.has(e)) {
    return true;
  }
  for (let n of t.watch) {
    if (e.startsWith(n) && e.charAt(n.length) === `.`) {
      return true;
    }
  }
  return false;
};
var ce = (e, t, n) => {
  for (let r of n || Object.keys(e)) {
    if (r === `_f`) {
      continue;
    }
    let i = n ? C(e, r) : e[r];
    if (i) {
      let {
        _f: e
      } = i;
      if (e) {
        if (e.refs && e.refs[0] && t(e.refs[0], e.name) || e.ref && t(e.ref, e.name) || ce(i, t)) {
          return true;
        }
      } else if ((u(i) || Array.isArray(i)) && ce(i, t)) {
        return true;
      }
    }
  }
};
var le = (e, t, n) => {
  let r = C(e, n);
  let i = Array.isArray(r) ? r : [];
  E(i, v, t[n]);
  E(e, n, i);
  return e;
};
var N = e => u(e) && !Object.keys(e).length;
var ue = e => {
  if (!m) {
    return false;
  }
  let t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
};
var P = e => e.type === `radio`;
var F = e => e instanceof RegExp;
var de = (e, t, n, r, i) => t ? {
  ...n[e],
  types: {
    ...(n[e] && n[e].types ? n[e].types : {}),
    [r]: i || true
  }
} : {};
var fe = {
  value: false,
  isValid: false
};
var pe = {
  value: true,
  isValid: true
};
var me = e => {
  if (!Array.isArray(e)) {
    return fe;
  }
  if (e.length > 1) {
    let t = e.filter(e => e && e.checked && !e.disabled).map(e => e.value);
    return {
      value: t,
      isValid: !!t.length
    };
  }
  let t = e[0];
  if (!t || !t.checked || t.disabled) {
    return fe;
  } else if (!t.attributes || !(`value` in t.attributes) || S(t.value) || t.value === ``) {
    return pe;
  } else {
    return {
      value: t.value,
      isValid: true
    };
  }
};
var I = {
  isValid: false,
  value: null
};
var he = e => Array.isArray(e) ? e.reduce((e, t) => t && t.checked && !t.disabled ? {
  isValid: true,
  value: t.value
} : e, I) : I;
function L(e, t, n = `validate`) {
  if (M(e) || Array.isArray(e) && e.every(M) || w(e) && !e) {
    return {
      type: n,
      message: M(e) ? e : ``,
      ref: t
    };
  }
}
var R = e => u(e) && !F(e) ? e : {
  value: e,
  message: ``
};
var ge = async (e, t, n, r, i, l) => {
  let {
    ref: d,
    refs: f,
    required: p,
    maxLength: ee,
    minLength: m,
    min: h,
    max: te,
    pattern: g,
    validate: v,
    name: y,
    valueAsNumber: b,
    mount: x
  } = e._f;
  let E = C(n, y);
  if (!x || t.has(y)) {
    return {};
  }
  let D = f ? f[0] : d;
  let O = e => {
    if (i && D.reportValidity) {
      let t = w(e) ? `` : e || ``;
      if (f) {
        f.forEach(e => e.setCustomValidity(t));
      } else {
        D.setCustomValidity(t);
      }
      D.reportValidity();
    }
  };
  let k = {};
  let ne = P(d);
  let re = a(d);
  let A = ne || re;
  let j = (b || o(d)) && S(d.value) && S(E) || ue(d) && d.value === `` || E === `` || Array.isArray(E) && !E.length;
  let ie = de.bind(null, y, r, k);
  let ae = (e, t, n, r = _.maxLength, i = _.minLength) => {
    let a = e ? t : n;
    k[y] = {
      type: e ? r : i,
      message: a,
      ref: d,
      ...ie(e ? r : i, a)
    };
  };
  if (l ? !Array.isArray(E) || !E.length : p && (!A && (j || c(E)) || w(E) && !E || re && !me(f).isValid || ne && !he(f).isValid)) {
    let {
      value: e,
      message: t
    } = M(p) ? {
      value: !!p,
      message: p
    } : R(p);
    if (e && (k[y] = {
      type: _.required,
      message: t,
      ref: D,
      ...ie(_.required, t)
    }, !r)) {
      O(t);
      return k;
    }
  }
  if (!j && (!c(h) || !c(te))) {
    let e;
    let t;
    let n = R(te);
    let i = R(h);
    if (!c(E) && !s(E) && !isNaN(E)) {
      let r = d.valueAsNumber || E && +E;
      if (!c(n.value)) {
        e = r > n.value;
      }
      if (!c(i.value)) {
        t = r < i.value;
      }
    } else {
      let r = d.valueAsDate || new Date(E);
      let a = e => new Date(`${new Date().toDateString()} ${e}`);
      let o = d.type == `time`;
      let s = d.type == `week`;
      if (M(n.value) && E) {
        e = o ? a(E) > a(n.value) : s ? E > n.value : r > new Date(n.value);
      }
      if (M(i.value) && E) {
        t = o ? a(E) < a(i.value) : s ? E < i.value : r < new Date(i.value);
      }
    }
    if ((e || t) && (ae(!!e, n.message, i.message, _.max, _.min), !r)) {
      O(k[y].message);
      return k;
    }
  }
  if ((ee || m) && !j && (M(E) || l && Array.isArray(E))) {
    let e = R(ee);
    let t = R(m);
    let n = !c(e.value) && E.length > +e.value;
    let i = !c(t.value) && E.length < +t.value;
    if ((n || i) && (ae(n, e.message, t.message), !r)) {
      O(k[y].message);
      return k;
    }
  }
  if (g && !j && M(E)) {
    let {
      value: e,
      message: t
    } = R(g);
    if (F(e) && !E.match(e) && (k[y] = {
      type: _.pattern,
      message: t,
      ref: d,
      ...ie(_.pattern, t)
    }, !r)) {
      O(t);
      return k;
    }
  }
  if (v) {
    if (T(v)) {
      let e = L(await v(E, n), D);
      if (e && (k[y] = {
        ...e,
        ...ie(_.validate, e.message)
      }, !r)) {
        O(e.message);
        return k;
      }
    } else if (u(v)) {
      let e = {};
      for (let t in v) {
        if (!N(e) && !r) {
          break;
        }
        let i = L(await v[t](E, n), D, t);
        if (i) {
          e = {
            ...i,
            ...ie(t, i.message)
          };
          if (!r) {
            O(i.message);
          }
          if (r) {
            k[y] = e;
          }
        }
      }
      if (!N(e) && (k[y] = {
        ref: D,
        ...e
      }, !r)) {
        return k;
      }
    }
  }
  let oe = k[y];
  O(!oe || oe.message);
  return k;
};
var _e = e => Array.isArray(e) ? e : [e];
var ve = e => Array.isArray(e) ? e.filter(Boolean) : [];
function ye(e, t) {
  let n = t.length - 1;
  let r = 0;
  while (r < n) {
    if (c(e)) {
      e = undefined;
      break;
    }
    e = e[t[r]];
    r++;
  }
  return e;
}
function be(e) {
  for (let t in e) {
    if (e.hasOwnProperty(t) && !S(e[t])) {
      return false;
    }
  }
  return true;
}
function z(e, t) {
  if (M(t) && Object.prototype.hasOwnProperty.call(e, t)) {
    delete e[t];
    return e;
  }
  let n = Array.isArray(t) ? t : x(t) ? [t] : p(t);
  if (n.some(e => y.includes(String(e)))) {
    return e;
  }
  let r = n.length === 1 ? e : ye(e, n);
  let i = n.length - 1;
  let a = n[i];
  if (r) {
    delete r[a];
  }
  if (i !== 0 && (u(r) && N(r) || Array.isArray(r) && be(r))) {
    z(e, n.slice(0, -1));
  }
  return e;
}
var xe = i.createContext(null);
xe.displayName = `HookFormContext`;
var Se = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: t => {
      for (let n of e) {
        if (n.next) {
          n.next(t);
        }
      }
    },
    subscribe: t => {
      e.push(t);
      return {
        unsubscribe: () => {
          e = e.filter(e => e !== t);
        }
      };
    },
    unsubscribe: () => {
      e = [];
    }
  };
};
function Ce(e, t) {
  let n = {};
  for (let r in e) {
    if (e.hasOwnProperty(r)) {
      let i = e[r];
      let a = t[r];
      if (i && u(i) && a) {
        let e = Ce(i, a);
        if (u(e)) {
          n[r] = e;
        }
      } else if (e[r]) {
        n[r] = a;
      }
    }
  }
  return n;
}
var we = (e, t) => e !== null && l(e) && Object.prototype.hasOwnProperty.call(e, t);
var Te = (e, t) => {
  if (!t) {
    return false;
  }
  let n = e;
  for (let r of x(t) ? [t] : p(t)) {
    if (!we(n, r)) {
      return we(e, t);
    }
    n = n[r];
  }
  return true;
};
var Ee = e => e.type === `select-multiple`;
var De = e => P(e) || a(e);
var Oe = e => ue(e) && e.isConnected;
function ke(e) {
  return Array.isArray(e) || u(e);
}
function Ae(e, t, n = ``, r = []) {
  for (let i in e) {
    let a = n ? `${n}.${i}` : i;
    let o = e[i];
    if (ke(o) && ke(C(t, a))) {
      Ae(o, t, a, r);
    } else {
      r.push(a);
    }
  }
  return r;
}
var je = e => {
  for (let t in e) {
    if (T(e[t])) {
      return true;
    }
  }
  return false;
};
function Me(e) {
  return Array.isArray(e) || u(e) && !je(e);
}
function Ne(e) {
  return !!e && !!(`_f` in e);
}
function Pe(e) {
  if (Array.isArray(e)) {
    return !e.some(e => !S(e));
  } else {
    return !Object.keys(e).length;
  }
}
function Fe(e, t) {
  if (Array.isArray(e)) {
    e[t] = undefined;
  } else {
    delete e[t];
  }
}
function Ie(e, t = {}, n) {
  for (let r in e) {
    let i = e[r];
    let a = n && n[r];
    if (Me(i) && (!Array.isArray(i) || !Ne(a))) {
      t[r] = Array.isArray(i) ? [] : {};
      Ie(i, t[r], a);
      if (Pe(t[r])) {
        Fe(t, r);
      }
    } else if (!S(i)) {
      t[r] = true;
    }
  }
  return t;
}
function Le(e, t, n, r) {
  n ||= Ie(t, {}, r);
  for (let i in e) {
    let a = e[i];
    let o = r && r[i];
    if (Me(a) && (!Array.isArray(a) || !Ne(o))) {
      if (S(t) || re(n[i])) {
        n[i] = Ie(a, Array.isArray(a) ? [] : {}, o);
      } else {
        Le(a, c(t) ? {} : t[i], n[i], o);
      }
      if (Pe(n[i])) {
        Fe(n, i);
      }
    } else if (j(a, t[i])) {
      Fe(n, i);
    } else {
      n[i] = true;
    }
  }
  return n;
}
var Re = (e, t) => {
  let n = t.split(`.`);
  let r = [];
  let i = n[0];
  for (let t = 1; t < n.length; i += `.${n[t++]}`) {
    if (!isNaN(+n[t]) && e.has(i)) {
      r.push(`${i}.${n[t]}`);
    }
  }
  return r;
};
var ze = (e, {
  valueAsNumber: t,
  valueAsDate: n,
  setValueAs: r
}) => S(e) ? e : t ? e === `` ? NaN : e && +e : n && M(e) ? new Date(e) : r ? r(e) : e;
function Be(e) {
  let t = e.ref;
  if (o(t)) {
    return t.files;
  } else if (P(t)) {
    return he(e.refs).value;
  } else if (Ee(t)) {
    return [...t.selectedOptions].map(({
      value: e
    }) => e);
  } else if (a(t)) {
    return me(e.refs).value;
  } else {
    return ze(t.value, e);
  }
}
var Ve = (e, t, n, r) => {
  let i = {};
  for (let n of e) {
    let e = C(t, n);
    if (e) {
      E(i, n, e._f);
    }
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: r
  };
};
var He = e => S(e) ? e : F(e) ? e.source : u(e) ? F(e.value) ? e.value.source : e.value : e;
var Ue = `AsyncFunction`;
var We = e => {
  if (!e || !e.validate) {
    return false;
  }
  if (T(e.validate)) {
    return e.validate.constructor.name === Ue;
  }
  if (u(e.validate)) {
    for (let t in e.validate) {
      if (e.validate[t].constructor.name === Ue) {
        return true;
      }
    }
  }
  return false;
};
var Ge = e => e.mount && (e.required || !S(e.required) && e.required !== false || !S(e.min) || !S(e.max) || !S(e.maxLength) || !S(e.minLength) || e.pattern || e.validate);
function Ke(e, t, n) {
  let r = C(e, n);
  if (r?.type || r?.message || Array.isArray(r)) {
    return {
      error: r,
      name: n
    };
  }
  let i = n.split(`.`);
  while (i.length) {
    let r = i.join(`.`);
    let a = C(t, r);
    let o = C(e, r);
    if (a && !Array.isArray(a) && n !== r) {
      return {
        name: n
      };
    }
    if (o && o.type) {
      return {
        name: r,
        error: o
      };
    }
    if (o && o.root && o.root.type) {
      return {
        name: `${r}.root`,
        error: o.root
      };
    }
    i.pop();
  }
  return {
    name: n
  };
}
var qe = (e, t, n, r) => {
  n(e);
  let i = Object.keys(e).filter(e => e !== `name`);
  return !i.length || r && i.length >= Object.keys(t).length || i.find(e => t[e] === (!r || g.all));
};
var Je = (e, t, n) => !e || !t || e === t || _e(e).some(e => e && (n ? e === t || e.startsWith(`${t}.`) : e.startsWith(t) || t.startsWith(e)));
var Ye = (e, t, n, r, i) => i.isOnAll ? false : !n && i.isOnTouch ? !t && !e : (n ? r.isOnBlur : i.isOnBlur) ? !e : !(n ? r.isOnChange : i.isOnChange) || e;
var Xe = (e, t) => {
  let n = C(e, t);
  if (!ve(n).length && (n == null || !n.root)) {
    z(e, t);
  }
};
var Ze = {
  mode: g.onSubmit,
  reValidateMode: g.onChange,
  shouldFocusError: true
};
var Qe = `form`;
var $e = (e, t) => {
  for (let n in e) {
    if (!(n in t)) {
      delete e[n];
    }
  }
  Object.assign(e, t);
};
var et = {
  submitCount: 0,
  isDirty: false,
  isReady: false,
  isValidating: false,
  isSubmitted: false,
  isSubmitting: false,
  isSubmitSuccessful: false,
  isValid: false,
  touchedFields: {},
  dirtyFields: {},
  validatingFields: {}
};
function tt(e = {}) {
  let t = {
    ...Ze,
    ...e
  };
  let n = {
    ...h(et),
    isLoading: T(t.defaultValues),
    errors: t.errors || {},
    disabled: t.disabled || false
  };
  let r = {};
  let i = (u(t.defaultValues) || u(t.values)) && h(t.defaultValues || t.values) || {};
  let l = t.shouldUnregister ? {} : h(i);
  let f = {
    action: false,
    actionArrayLengths: new Map(),
    mount: false,
    watch: false,
    keepIsValid: false
  };
  let y = {
    mount: new Set(),
    disabled: new Set(),
    unMount: new Set(),
    array: new Set(),
    watch: new Set(),
    registerName: new Set()
  };
  let b = {};
  let D = {};
  let O = 0;
  let k = oe(t.mode);
  let ne = oe(t.reValidateMode);
  let re = {
    isDirty: false,
    dirtyFields: false,
    validatingFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  };
  let A = {
    ...re
  };
  let ie = {
    ...A
  };
  let P = (...e) => e.some(e => A[e] || ie[e]);
  let F = {
    array: Se(),
    state: Se()
  };
  let de = 0;
  let fe = 0;
  let pe = t.criteriaMode === g.all;
  let me = (e, t) => n => {
    clearTimeout(D[e]);
    D[e] = setTimeout(t, n);
  };
  let I = e => {
    clearTimeout(D[e]);
    delete D[e];
    delete b[e];
  };
  let he = e => {
    I(e);
    let t = `${e}.`;
    for (let e of Object.keys(b)) {
      if (e.startsWith(t)) {
        I(e);
      }
    }
  };
  let L = async e => {
    if (!f.keepIsValid && !t.disabled && (P(`isValid`) || e)) {
      let e = ++de;
      let i;
      if (t.resolver) {
        i = N((await Fe()).errors);
        if (e === de) {
          R();
        }
      } else {
        i = await tt({
          fields: r,
          onlyCheckValid: true,
          eventType: te.VALID
        });
      }
      if (e === de && i !== n.isValid) {
        F.state.next({
          isValid: i
        });
      }
    }
  };
  let R = (e, r) => {
    if (!t.disabled && P(`isValidating`, `validatingFields`)) {
      (e || y.mount).forEach(e => {
        if (e) {
          if (r) {
            E(n.validatingFields, e, r);
          } else {
            z(n.validatingFields, e);
          }
        }
      });
      F.state.next({
        validatingFields: n.validatingFields,
        isValidating: !N(n.validatingFields)
      });
    }
  };
  let ye = () => {
    n.dirtyFields = Le(i, l, undefined, r);
  };
  let be = (e, i = [], a, o, s = true, c = true) => {
    if (o && a && !t.disabled) {
      f.action = true;
      let t = C(r, e);
      if (!f.actionArrayLengths.has(e)) {
        f.actionArrayLengths.set(e, Array.isArray(t) ? t.length : 0);
      }
      if (c && Array.isArray(t)) {
        let n = a(t, o.argA, o.argB);
        if (s) {
          E(r, e, n);
        }
      }
      let l = C(n.errors, e);
      if (c && Array.isArray(l)) {
        let t = l.root;
        let r = a(l, o.argA, o.argB) || l;
        if (t) {
          r.root = t;
        }
        if (s) {
          E(n.errors, e, r);
        }
        Xe(n.errors, e);
      }
      let u = C(n.touchedFields, e);
      if (P(`touchedFields`) && c && Array.isArray(u)) {
        let t = a(u, o.argA, o.argB);
        if (s) {
          E(n.touchedFields, e, t);
        }
      }
      if (P(`dirtyFields`)) {
        ye();
      }
      F.state.next({
        name: e,
        isDirty: rt(e, i),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else {
      E(l, e, i);
    }
  };
  let xe = (e, t) => {
    E(n.errors, e, t);
    n.errors = {
      ...n.errors
    };
    F.state.next({
      errors: n.errors
    });
  };
  let we = e => {
    Object.keys(b).forEach(I);
    n.errors = e;
    F.state.next({
      errors: n.errors,
      isValid: false
    });
  };
  let ke = e => {
    let t = x(e) ? [e] : p(e);
    let n = l;
    let r = i;
    for (let e = 0; e < t.length - 1; e++) {
      let i = t[e];
      n = c(n) ? n : n[i];
      r = c(r) ? r : r[i];
      if (n === null && r !== null) {
        return true;
      }
    }
    return false;
  };
  let je = e => {
    if (!f.actionArrayLengths.size) {
      return false;
    }
    let t = x(e) ? [e] : p(e);
    let n = l;
    let r = ``;
    let i = -1;
    let a = 0;
    for (let e = 0; e < t.length; e++) {
      if (c(n)) {
        return false;
      }
      let o = t[e];
      r = r ? `${r}.${o}` : o;
      if (Array.isArray(n) && +o >= n.length) {
        if (i === -1) {
          return false;
        } else {
          return e !== i || +o < a;
        }
      }
      if (f.actionArrayLengths.has(r)) {
        i = e + 1;
        a = f.actionArrayLengths.get(r);
      }
      n = n[o];
      if (S(n) && i !== -1 && e > i && +t[i] < a) {
        return true;
      }
    }
    return false;
  };
  let Me = (t, a, o, s) => {
    let c = C(r, t);
    if (c) {
      if (ke(t) || je(t)) {
        return;
      }
      let r = S(C(l, t));
      let u = C(l, t, S(o) ? C(i, t) : o);
      if (S(u) || s && s.defaultChecked || a) {
        E(l, t, a ? u : Be(c._f));
      } else {
        ot(t, u);
      }
      if (f.mount && !f.action) {
        L();
        if (r && n.isDirty && P(`isDirty`)) {
          if (!rt()) {
            n.isDirty = false;
            F.state.next({
              ...n
            });
          }
        }
        if (e.shouldUnregister && r && !S(C(l, t)) && se(t, y)) {
          f.watch = true;
        }
      }
    }
  };
  let Ne = (e, a, o, s, c) => {
    let u = false;
    let d = false;
    let f = {
      name: e
    };
    if (!t.disabled || s === true) {
      if (!o || s) {
        let t = j(C(i, e), a);
        if (P(`isDirty`)) {
          d = n.isDirty;
          n.isDirty = f.isDirty = !t || rt();
          u = d !== f.isDirty;
        }
        d = !!C(n.dirtyFields, e);
        if (t === n.isDirty) {
          if (t) {
            z(n.dirtyFields, e);
          } else {
            E(n.dirtyFields, e, true);
          }
        } else {
          $e(n.dirtyFields, Le(i, l, undefined, r));
        }
        f.dirtyFields = n.dirtyFields;
        u ||= P(`dirtyFields`) && d !== !t;
      }
      if (o) {
        let t = C(n.touchedFields, e);
        if (!t) {
          E(n.touchedFields, e, o);
          f.touchedFields = n.touchedFields;
          u ||= P(`touchedFields`) && t !== o;
        }
      }
      if (u && c) {
        F.state.next(f);
      }
    }
    if (u) {
      return f;
    } else {
      return {};
    }
  };
  let Pe = (e, r, i, a) => {
    let o = C(n.errors, e);
    let s = P(`isValid`) && w(r) && n.isValid !== r;
    if (t.delayError && i) {
      b[e] = me(e, () => xe(e, i));
      b[e](t.delayError);
    } else {
      I(e);
      if (i) {
        E(n.errors, e, i);
      } else {
        z(n.errors, e);
      }
      n.errors = {
        ...n.errors
      };
    }
    if ((i ? !j(o, i) : o) || !N(a) || s) {
      let t = {
        ...a,
        ...(s && w(r) ? {
          isValid: r
        } : {}),
        errors: n.errors,
        name: e
      };
      F.state.next(t);
    }
  };
  let Fe = async e => {
    R(e, true);
    return await t.resolver(l, t.context, Ve(e || y.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
  };
  let Ie = async e => {
    let t = fe;
    let {
      errors: i
    } = await Fe(e);
    if (t !== fe) {
      return i;
    }
    R(e);
    if (e) {
      for (let t of e) {
        let e = C(i, t);
        I(t);
        let a = y.array.has(t) && u(e) && !Object.keys(e).some(e => !Number.isNaN(Number(e)));
        let o = C(r, t);
        let s = u(o) && Object.keys(o).some(e => e !== `_f`);
        if (a) {
          le(n.errors, {
            [t]: e
          }, t);
        } else if (e?.type || e?.message || Array.isArray(e) || u(e) && s) {
          E(n.errors, t, e);
        } else {
          z(n.errors, t);
        }
      }
      n.errors = {
        ...n.errors
      };
    } else {
      Object.keys(b).forEach(I);
      n.errors = i;
    }
    return i;
  };
  let Ue = async ({
    name: t,
    eventType: r
  }) => {
    if (e.validate) {
      let i = await e.validate({
        formValues: l,
        formState: n,
        name: t,
        eventType: r
      });
      if (u(i)) {
        for (let e in i) {
          let t = i[e];
          if (t) {
            mt(`${Qe}.${e}`, {
              message: M(t.message) ? t.message : ``,
              type: t.type || _.validate
            });
          }
        }
      } else if (M(i) || !i) {
        mt(Qe, {
          message: i || ``,
          type: _.validate
        });
      } else {
        pt(Qe);
      }
      return i;
    }
    return true;
  };
  let tt = async ({
    fields: r,
    onlyCheckValid: i,
    name: a,
    eventType: o,
    context: s = {
      valid: true,
      runRootValidation: false
    }
  }) => {
    if (e.validate && (s.runRootValidation = true, !(await Ue({
      name: a,
      eventType: o
    })) && (s.valid = false, i))) {
      return s.valid;
    }
    for (let a in r) {
      let c = r[a];
      if (c) {
        let {
          _f: r,
          ...u
        } = c;
        if (r) {
          let a = y.array.has(r.name);
          let o = c._f && We(c._f);
          let u = P(`isValidating`, `validatingFields`);
          if (o && u) {
            R([r.name], true);
          }
          let d = await ge(c, y.disabled, l, pe, t.shouldUseNativeValidation && !i, a);
          if (o && u) {
            R([r.name]);
          }
          if (d[r.name] && (s.valid = false, i) || (i || (I(r.name), C(d, r.name) ? a ? le(n.errors, d, r.name) : E(n.errors, r.name, d[r.name]) : z(n.errors, r.name)), e.shouldUseNativeValidation && d[r.name])) {
            break;
          }
        }
        if (!N(u)) {
          await tt({
            context: s,
            onlyCheckValid: i,
            fields: u,
            name: a,
            eventType: o
          });
        }
      }
    }
    return s.valid;
  };
  let nt = () => {
    for (let e of y.unMount) {
      let t = C(r, e);
      if (t && (t._f.refs ? t._f.refs.every(e => !Oe(e)) : !Oe(t._f.ref))) {
        K(e);
      }
    }
    y.unMount = new Set();
  };
  let rt = (e, t) => {
    if (e && t) {
      E(l, e, t);
    }
    return !j(f.mount ? l : i, i);
  };
  let it = (e, t, n) => ae(e, y, {
    ...(f.mount ? l : S(t) || M(e) ? i : t)
  }, n, t);
  let at = e => ve(C(f.mount ? l : i, e, t.shouldUnregister ? C(i, e, []) : []));
  let ot = (e, t, n = {}, i = false, s = false, u = false) => {
    let d = C(r, e);
    let f = t;
    if (d) {
      let n = d._f;
      if (n) {
        if (!n.disabled) {
          E(l, e, ze(t, n));
        }
        f = ue(n.ref) && c(t) ? `` : t;
        if (Ee(n.ref)) {
          [...n.ref.options].forEach(e => e.selected = f.includes(e.value));
        } else if (n.refs) {
          if (a(n.ref)) {
            n.refs.forEach(e => {
              if (!e.defaultChecked || !e.disabled) {
                e.checked = Array.isArray(f) ? !!f.find(t => t === e.value) : f === e.value || !!f;
              }
            });
          } else {
            n.refs.forEach(e => e.checked = e.value === f);
          }
        } else if (o(n.ref)) {
          n.ref.value = ``;
        } else {
          n.ref.value = f;
          if (!n.ref.type && !s && !u) {
            F.state.next({
              name: e,
              values: i ? l : h(l)
            });
          }
        }
      }
    }
    if (n.shouldDirty || n.shouldTouch) {
      Ne(e, d && d._f && !d._f.disabled && (d._f.valueAsNumber || d._f.valueAsDate || d._f.setValueAs) ? ze(t, d._f) : f, n.shouldTouch, n.shouldDirty, !s);
    }
    if (n.shouldValidate) {
      dt(e, {
        delayError: n.delayError
      });
    }
  };
  let st = (e, t, n, i = false, a = false, o = false) => {
    if (y.array.has(e)) {
      F.array.next({
        name: e,
        values: i ? l : h(l)
      });
    }
    for (let c in t) {
      if (!t.hasOwnProperty(c)) {
        continue;
      }
      let l = t[c];
      let d = `${e}.${c}`;
      let f = C(r, d);
      if ((y.array.has(e) || u(l) || f && !f._f) && !s(l)) {
        st(d, l, n, i, a, o);
      } else {
        ot(d, l, n, i, a, o);
      }
    }
  };
  let ct = (e, t, i, a, o = false) => {
    let s = C(r, e);
    let u = y.array.has(e);
    let d = a ? t : h(t);
    let p = j(C(l, e), d);
    if (!p) {
      E(l, e, d);
    }
    if (u) {
      F.array.next({
        name: e,
        values: a ? l : h(l)
      });
      if (P(`isDirty`, `dirtyFields`) && i.shouldDirty) {
        ye();
        if (!o) {
          F.state.next({
            name: e,
            dirtyFields: n.dirtyFields,
            isDirty: rt(e, d)
          });
        }
      }
    } else {
      let t = Array.isArray(d) && !d.length || N(d);
      let n = !p && !o;
      if (!s || s._f || c(d) || t) {
        ot(e, d, i, a, o, n);
      } else {
        st(e, d, i, a, o, n);
      }
    }
    if (!p && !o) {
      let t = se(e, y);
      let r = a ? l : h(l);
      F.state.next({
        ...(t && n),
        name: f.mount || t ? e : undefined,
        values: r
      });
      if (!u) {
        for (let t of Re(y.array, e)) {
          F.state.next({
            name: t,
            values: r
          });
        }
      }
    }
  };
  let lt = (e, t, n = {}) => ct(e, t, n, false);
  let B = (e, t = {}) => {
    let r = T(e) ? e(l) : e;
    if (!j(l, r)) {
      l = {
        ...l,
        ...r
      };
      for (let e of y.mount) {
        if (Te(r, e)) {
          ct(e, C(r, e), t, true, true);
        }
      }
      F.state.next({
        ...n,
        name: undefined,
        type: undefined,
        ...(O ? {
          values: l
        } : {})
      });
      if (t.shouldValidate) {
        L();
      }
    }
  };
  let ut = async i => {
    f.mount = true;
    let a = i.target;
    let o = a.name;
    let c = true;
    let u = C(r, o);
    let p = e => {
      c = Number.isNaN(e) || s(e) && isNaN(e.getTime()) || j(e, C(l, o, e));
    };
    if (u) {
      let s;
      let f;
      let ee = a.type ? Be(u._f) : d(i);
      let m = i.type === te.BLUR || i.type === te.FOCUS_OUT;
      let g = !Ge(u._f) && !e.validate && !t.resolver && !C(n.errors, o) && !u._f.deps;
      let _ = g || Ye(m, C(n.touchedFields, o), n.isSubmitted, ne, k);
      let v = se(o, y, m);
      E(l, o, h(ee));
      if (m) {
        if (!a || !a.readOnly) {
          if (u._f.onBlur) {
            u._f.onBlur(i);
          }
          let e = b[o];
          if (e) {
            e(0);
          }
        }
      } else if (u._f.onChange) {
        u._f.onChange(i);
      }
      let x = Ne(o, ee, m);
      let S = !N(x) || v;
      if (!m) {
        F.state.next({
          name: o,
          type: i.type,
          ...(O ? {
            values: h(l)
          } : {})
        });
      }
      if (_) {
        if ((!g || !n.isValid) && P(`isValid`)) {
          if (t.mode === `onBlur`) {
            if (m) {
              L();
            }
          } else if (!m) {
            L();
          }
        }
        return S && F.state.next({
          name: o,
          ...(v ? {} : x)
        });
      }
      if (!t.resolver && e.validate) {
        await Ue({
          name: o,
          eventType: i.type
        });
      }
      if (!m && v) {
        F.state.next({
          ...n
        });
      }
      if (t.resolver) {
        let {
          errors: e
        } = await Fe([o]);
        R([o]);
        p(ee);
        if (!c) {
          if (!N(x)) {
            F.state.next(x);
          }
          return;
        }
        let t = Ke(n.errors, r, o);
        let i = Ke(e, r, t.name || o);
        s = i.error;
        o = i.name;
        f = N(e);
      } else {
        R([o], true);
        s = (await ge(u, y.disabled, l, pe, t.shouldUseNativeValidation))[o];
        R([o]);
        p(ee);
        if (c) {
          if (s) {
            f = false;
          } else if (P(`isValid`)) {
            f = await tt({
              fields: r,
              onlyCheckValid: true,
              name: o,
              eventType: i.type
            });
          }
        }
      }
      if (c) {
        if (u._f.deps && (!Array.isArray(u._f.deps) || u._f.deps.length > 0)) {
          dt(u._f.deps);
        }
        Pe(o, f, s, x);
      }
    }
  };
  let V = (e, t) => {
    if (C(n.errors, t) && e.focus) {
      e.focus();
      return 1;
    }
  };
  let dt = async (e, i = {}) => {
    let a;
    let o;
    let s = _e(e);
    if (t.resolver) {
      let t = fe;
      let n = await Ie(S(e) ? e : s);
      a = N(n);
      o = e ? !s.some(e => C(n, e)) : a;
      if (t !== fe) {
        return o;
      }
    } else if (e) {
      o = (await Promise.all(s.map(async e => {
        let t = C(r, e);
        return await tt({
          fields: t && t._f ? {
            [e]: t
          } : t,
          eventType: te.TRIGGER
        });
      }))).every(Boolean);
      if (o || n.isValid) {
        L();
      }
    } else {
      o = a = await tt({
        fields: r,
        name: e,
        eventType: te.TRIGGER
      });
    }
    if (i.delayError && t.delayError && M(e)) {
      let r = C(n.errors, e);
      if (r) {
        z(n.errors, e);
        b[e] = me(e, () => xe(e, r));
        b[e](t.delayError);
      } else {
        I(e);
      }
    }
    if (i.shouldTouch) {
      for (let t of e ? s : y.mount) {
        if (!y.array.has(t)) {
          E(n.touchedFields, t, true);
        }
      }
    }
    F.state.next({
      ...(!M(e) || P(`isValid`) && a !== n.isValid ? {} : {
        name: e
      }),
      ...(t.resolver || !e ? {
        isValid: a
      } : {}),
      ...(i.shouldTouch && P(`touchedFields`) ? {
        touchedFields: n.touchedFields
      } : {}),
      errors: n.errors
    });
    if (i.shouldFocus && !o) {
      ce(r, V, e ? s : y.mount);
    }
    return o;
  };
  let H = (e, t) => {
    let r = {
      ...(f.mount ? l : i)
    };
    if (t) {
      r = Ce(t.dirtyFields ? n.dirtyFields : n.touchedFields, r);
    }
    if (S(e)) {
      return r;
    } else if (M(e)) {
      return C(r, e);
    } else {
      return e.map(e => C(r, e));
    }
  };
  let U = e => S(e) ? {
    ...n.errors
  } : M(e) ? C(n.errors, e) : e.map(e => C(n.errors, e));
  let ft = (e, t) => {
    let r = t || n;
    let i = C(r.errors, e);
    return {
      invalid: !!i,
      isDirty: !!C(r.dirtyFields, e),
      error: i,
      isValidating: !!C(r.validatingFields, e),
      isTouched: !!C(r.touchedFields, e)
    };
  };
  let pt = e => {
    let t = e ? _e(e) : undefined;
    if (t) {
      t.forEach(e => {
        he(e);
        z(n.errors, e);
        F.state.next({
          name: e,
          errors: n.errors
        });
      });
    } else {
      Object.keys(b).forEach(I);
      n.errors = {};
      F.state.next({
        errors: n.errors
      });
    }
  };
  let mt = (e, t, i) => {
    I(e);
    let a = (C(r, e, {
      _f: {}
    })._f || {}).ref;
    let {
      ref: o,
      message: s,
      type: c,
      types: l,
      ...u
    } = C(n.errors, e) || {};
    E(n.errors, e, {
      ...u,
      ...t,
      ref: a
    });
    F.state.next({
      name: e,
      errors: n.errors,
      isValid: false
    });
    if (i && i.shouldFocus && a && a.focus) {
      a.focus();
    }
  };
  let ht = (e, t) => {
    if (T(e)) {
      O++;
      let {
        unsubscribe: n
      } = F.state.subscribe({
        next: n => `values` in n && e(n.values || it(undefined, t), n)
      });
      let r = false;
      return {
        unsubscribe: () => {
          if (!r) {
            r = true;
            O--;
            n();
          }
        }
      };
    }
    return it(e, t, true);
  };
  let W = e => {
    let t = !!e.formState?.values;
    if (t) {
      O++;
    }
    let {
      unsubscribe: r
    } = F.state.subscribe({
      next: t => {
        if (Je(e.name, t.name, e.exact) && qe(t, e.formState || A, X, e.reRenderRoot)) {
          let r = {
            ...l
          };
          e.callback({
            values: r,
            ...n,
            ...t,
            defaultValues: i
          });
        }
      }
    });
    if (!t) {
      return r;
    }
    let a = false;
    return () => {
      if (!a) {
        a = true;
        O--;
        r();
      }
    };
  };
  let G = e => {
    f.mount = true;
    ie = {
      ...ie,
      ...e.formState
    };
    return W({
      ...e,
      formState: {
        ...re,
        ...e.formState
      }
    });
  };
  let K = (e, a = {}) => {
    for (let o of e ? _e(e) : y.mount) {
      y.mount.delete(o);
      y.array.delete(o);
      y.disabled.delete(o);
      if (!a.keepValue) {
        z(r, o);
        z(l, o);
      }
      if (!a.keepError) {
        he(o);
        z(n.errors, o);
      }
      if (!a.keepDirty) {
        z(n.dirtyFields, o);
      }
      if (!a.keepTouched) {
        z(n.touchedFields, o);
      }
      if (!a.keepIsValidating) {
        z(n.validatingFields, o);
      }
      if (!t.shouldUnregister && !a.keepDefaultValue) {
        z(i, o);
      }
    }
    if (O) {
      F.state.next({
        values: h(l)
      });
    }
    F.state.next({
      ...n,
      ...(a.keepDirty ? {} : {
        isDirty: rt()
      }),
      ...(a.keepIsValidating ? {} : {
        isValidating: !N(n.validatingFields)
      })
    });
    if (!a.keepIsValid) {
      L();
    }
  };
  let gt = ({
    disabled: e,
    name: t
  }) => {
    if (w(e) && f.mount || e || y.disabled.has(t)) {
      let n = y.disabled.has(t) !== !!e;
      if (e) {
        y.disabled.add(t);
      } else {
        y.disabled.delete(t);
      }
      if (n && f.mount && !f.action) {
        L();
      }
    }
  };
  let q = (e, n = {}) => {
    let a = C(r, e);
    let o = w(n.disabled) || w(t.disabled);
    let s = !y.registerName.has(e) && a && a._f && !a._f.mount;
    E(r, e, {
      ...(a || {}),
      _f: {
        ...(a && a._f ? a._f : {
          ref: {
            name: e
          }
        }),
        name: e,
        mount: true,
        ...n
      }
    });
    y.mount.add(e);
    if (a && !s) {
      gt({
        disabled: w(n.disabled) ? n.disabled : t.disabled,
        name: e
      });
    } else {
      Me(e, true, n.value);
    }
    return {
      ...(o ? {
        disabled: n.disabled || t.disabled
      } : {}),
      ...(t.progressive ? {
        required: !!n.required,
        min: He(n.min),
        max: He(n.max),
        minLength: He(n.minLength),
        maxLength: He(n.maxLength),
        pattern: He(n.pattern)
      } : {}),
      name: e,
      onChange: ut,
      onBlur: ut,
      ref: o => {
        if (o) {
          y.registerName.add(e);
          q(e, n);
          y.registerName.delete(e);
          a = C(r, e);
          let t = S(o.value) && o.querySelectorAll && o.querySelectorAll(`input,select,textarea`)[0] || o;
          let s = De(t);
          let c = a._f.refs || [];
          if (s ? c.find(e => e === t) : t === a._f.ref) {
            return;
          }
          let l = {
            ...a._f
          };
          if (s) {
            l.refs = [...c.filter(Oe), t, ...(Array.isArray(C(i, e)) ? [{}] : [])];
            l.ref = {
              type: t.type,
              name: e
            };
          } else {
            l.ref = t;
            delete l.refs;
          }
          E(r, e, {
            _f: l
          });
          Me(e, false, undefined, t);
        } else {
          a = C(r, e, {});
          if (a._f) {
            a._f.mount = false;
          }
          if ((t.shouldUnregister || n.shouldUnregister) && (!ee(y.array, e) || !f.action)) {
            y.unMount.add(e);
          }
        }
      }
    };
  };
  let _t = () => t.shouldFocusError && !t.shouldUseNativeValidation && ce(r, V, y.mount);
  let vt = e => {
    if (w(e)) {
      F.state.next({
        disabled: e
      });
      ce(r, (t, n) => {
        let i = C(r, n);
        if (i) {
          t.disabled = i._f.disabled || e;
          if (Array.isArray(i._f.refs)) {
            i._f.refs.forEach(t => {
              t.disabled = i._f.disabled || e;
            });
          }
        }
      }, 0);
    }
  };
  let yt = (e, i) => async a => {
    let o;
    let s;
    if (a) {
      if (a.preventDefault) {
        a.preventDefault();
      }
      if (a.persist) {
        a.persist();
      }
    }
    let c = h(l);
    F.state.next({
      isSubmitting: true
    });
    if (t.resolver) {
      let e = fe;
      let {
        errors: t,
        values: r
      } = await Fe();
      if (e !== fe) {
        return;
      }
      R();
      Object.keys(b).forEach(I);
      n.errors = t;
      c = h(r);
    } else {
      await tt({
        fields: r,
        eventType: te.SUBMIT
      });
      z(n.errors, v);
    }
    if (y.disabled.size) {
      for (let e of y.disabled) {
        z(c, e);
      }
    }
    if (N(n.errors)) {
      F.state.next({
        errors: {}
      });
      try {
        o = await e(c, a);
      } catch (e) {
        s = e;
      }
    } else {
      if (i) {
        await i({
          ...n.errors
        }, a);
      }
      _t();
      setTimeout(_t);
    }
    F.state.next({
      isSubmitted: true,
      isSubmitting: false,
      isSubmitSuccessful: N(n.errors) && !s,
      submitCount: n.submitCount + 1,
      errors: n.errors
    });
    if (s) {
      throw s;
    }
    return o;
  };
  let bt = (e, t = {}) => {
    if (C(r, e)) {
      z(n.validatingFields, e);
      if (S(t.defaultValue)) {
        lt(e, h(C(i, e)));
      } else {
        lt(e, t.defaultValue);
        E(i, e, h(t.defaultValue));
      }
      if (!t.keepTouched) {
        z(n.touchedFields, e);
      }
      if (!t.keepDirty) {
        z(n.dirtyFields, e);
        n.isDirty = t.defaultValue ? rt(e, h(C(i, e))) : rt();
      }
      if (!t.keepError) {
        I(e);
        z(n.errors, e);
        L();
      }
      F.state.next({
        ...n,
        isValidating: !N(n.validatingFields)
      });
    }
  };
  let J = (e, a = {}) => {
    fe++;
    let o = e ? h(e) : i;
    let s = h(o);
    let c = N(e);
    let u = s;
    let d = r;
    Object.keys(b).forEach(I);
    if (!a.keepDefaultValues) {
      i = o;
    }
    if (!a.keepValues) {
      if (a.keepDirtyValues) {
        let e = new Set([...y.mount, ...Ae(Le(i, l, undefined, d), n.dirtyFields)]);
        for (let t of e) {
          let e = C(n.dirtyFields, t);
          let r = C(l, t);
          let i = C(u, t);
          if (e && !S(r)) {
            E(u, t, r);
          } else if (!e && !S(i)) {
            lt(t, i);
          }
        }
      } else {
        if (m && S(e)) {
          for (let e of y.mount) {
            let t = C(r, e);
            if (t && t._f) {
              let e = Array.isArray(t._f.refs) ? t._f.refs[0] : t._f.ref;
              if (ue(e)) {
                let t = e.closest(`form`);
                if (t) {
                  t.reset();
                  break;
                }
              }
            }
          }
        }
        if (a.keepFieldsRef) {
          for (let e of y.mount) {
            lt(e, C(u, e));
          }
        } else {
          r = {};
        }
      }
      if (t.shouldUnregister) {
        l = a.keepDefaultValues ? h(i) : {};
        if (a.keepFieldsRef) {
          for (let e of y.mount) {
            E(l, e, C(u, e));
          }
        }
      } else {
        l = h(u);
      }
      F.array.next({
        values: {
          ...u
        }
      });
      F.state.next({
        name: undefined,
        type: undefined,
        values: {
          ...u
        }
      });
    }
    y = {
      mount: a.keepDirtyValues ? y.mount : new Set(),
      unMount: new Set(),
      array: new Set(),
      registerName: new Set(),
      disabled: new Set(),
      watch: new Set(),
      watchAll: false,
      focus: ``
    };
    f.mount = !A.isValid || !!a.keepIsValid || !!a.keepDirtyValues || !t.shouldUnregister && !N(u);
    f.watch = !!t.shouldUnregister;
    f.keepIsValid = !!a.keepIsValid;
    f.action = false;
    f.actionArrayLengths.clear();
    if (!a.keepErrors) {
      n.errors = {};
    }
    F.state.next({
      submitCount: a.keepSubmitCount ? n.submitCount : 0,
      isDirty: c ? false : a.keepDirty ? n.isDirty : a.keepValues ? rt() : !!a.keepDefaultValues && !j(e, i),
      isSubmitted: a.keepIsSubmitted ? n.isSubmitted : false,
      dirtyFields: c ? {} : a.keepDirtyValues ? a.keepDefaultValues && l ? Le(i, l, undefined, d) : n.dirtyFields : a.keepDefaultValues && e ? Le(i, e, undefined, d) : a.keepDirty ? n.dirtyFields : a.keepValues ? Le(i, l, undefined, d) : {},
      touchedFields: a.keepTouched ? n.touchedFields : {},
      ...(!a.keepIsValidating && (n.isValidating || !N(n.validatingFields)) ? {
        validatingFields: {},
        isValidating: false
      } : null),
      errors: a.keepErrors ? n.errors : {},
      isSubmitSuccessful: a.keepIsSubmitSuccessful ? n.isSubmitSuccessful : false,
      isSubmitting: false,
      defaultValues: i
    });
  };
  let Y = (e, n) => J(T(e) ? e(l) : e, {
    ...t.resetOptions,
    ...n
  });
  let xt = (e, t = {}) => {
    let n = C(r, e);
    let i = n && n._f;
    if (i) {
      let e = i.refs ? i.refs[0] : i.ref;
      if (e.focus) {
        setTimeout(() => {
          e.focus();
          if (t.shouldSelect && T(e.select)) {
            e.select();
          }
        });
      }
    }
  };
  let X = e => {
    let {
      name: t,
      type: r,
      values: i,
      ...a
    } = e;
    n = {
      ...n,
      ...a
    };
  };
  F.state.subscribe({
    next: X
  });
  let Z = {
    control: {
      register: q,
      unregister: K,
      getFieldState: ft,
      handleSubmit: yt,
      setError: mt,
      _subscribe: W,
      _runSchema: Fe,
      _updateIsValidating: R,
      _focusError: _t,
      _getWatch: it,
      _getDirty: rt,
      _setValid: L,
      _setFieldArray: be,
      _setDisabledField: gt,
      _setErrors: we,
      _getFieldArray: at,
      _reset: J,
      _resetDefaultValues: () => T(t.defaultValues) && t.defaultValues().then(e => {
        Y(e, t.resetOptions);
        F.state.next({
          isLoading: false
        });
      }),
      _removeUnmounted: nt,
      _disableForm: vt,
      _subjects: F,
      _proxyFormState: A,
      get _fields() {
        return r;
      },
      get _formValues() {
        return l;
      },
      get _state() {
        return f;
      },
      set _state(e) {
        f = e;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return y;
      },
      set _names(e) {
        y = e;
      },
      get _formState() {
        return n;
      },
      get _options() {
        return t;
      },
      set _options(e) {
        t = {
          ...t,
          ...e
        };
        k = oe(t.mode);
        ne = oe(t.reValidateMode);
        pe = t.criteriaMode === g.all;
      }
    },
    subscribe: G,
    trigger: dt,
    register: q,
    handleSubmit: yt,
    watch: ht,
    setValue: lt,
    setValues: B,
    getValues: H,
    getErrors: U,
    reset: Y,
    resetField: bt,
    resetDefaultValues: (e, t = {}) => {
      i = h(e);
      if (!t.keepDirty) {
        let e = Le(i, l, undefined, r);
        n.dirtyFields = e;
        n.isDirty = !N(e);
      }
      if (!t.keepIsValid) {
        L();
      }
      F.state.next({
        ...n,
        defaultValues: i
      });
    },
    clearErrors: pt,
    unregister: K,
    setError: mt,
    setFocus: xt,
    getFieldState: ft
  };
  return {
    ...Z,
    formControl: Z
  };
}
function nt(e = {}) {
  let t = i.useRef(undefined);
  let n = i.useRef(undefined);
  let r = i.useRef(e.formControl);
  let [a, o] = i.useState(() => ({
    ...h(et),
    isLoading: T(e.defaultValues),
    errors: e.errors || {},
    disabled: e.disabled || false,
    defaultValues: T(e.defaultValues) ? undefined : e.defaultValues
  }));
  if (!t.current || e.formControl && r.current !== e.formControl) {
    r.current = e.formControl;
    if (e.formControl) {
      t.current = {
        ...e.formControl,
        formState: a
      };
      if (e.defaultValues && !T(e.defaultValues)) {
        e.formControl.reset(e.defaultValues, e.resetOptions);
      }
    } else {
      let {
        formControl: n,
        ...r
      } = tt(e);
      t.current = {
        ...r,
        formState: a
      };
    }
  }
  let s = t.current.control;
  s._options = e;
  let c = () => ({
    ...s._formState,
    defaultValues: s._defaultValues
  });
  let {
    resyncIfNeeded: l,
    snapshot: u
  } = ie(c);
  k(() => {
    l(true, c, o);
    let e = s._subscribe({
      formState: s._proxyFormState,
      callback: () => o({
        ...s._formState,
        defaultValues: s._defaultValues
      }),
      reRenderRoot: true
    });
    o(e => ({
      ...e,
      isReady: true
    }));
    s._formState.isReady = true;
    return () => {
      e();
      u(true, c);
    };
  }, [s, l, u]);
  i.useEffect(() => s._disableForm(e.disabled), [s, e.disabled]);
  i.useEffect(() => {
    if (e.mode) {
      s._options.mode = e.mode;
    }
    if (e.reValidateMode) {
      s._options.reValidateMode = e.reValidateMode;
    }
  }, [s, e.mode, e.reValidateMode]);
  i.useEffect(() => {
    if (e.errors) {
      s._setErrors(e.errors);
      s._focusError();
    }
  }, [s, e.errors]);
  i.useEffect(() => {
    if (e.shouldUnregister) {
      s._subjects.state.next({
        values: s._getWatch()
      });
    }
  }, [s, e.shouldUnregister]);
  i.useEffect(() => {
    if (s._proxyFormState.isDirty) {
      let e = s._getDirty();
      if (e !== a.isDirty) {
        s._subjects.state.next({
          isDirty: e
        });
      }
    }
  }, [s, a.isDirty]);
  i.useEffect(() => {
    if (e.values && !j(e.values, n.current)) {
      s._reset(e.values, {
        keepFieldsRef: true,
        ...s._options.resetOptions
      });
      if (!s._options.resetOptions?.keepIsValid) {
        s._setValid();
      }
      n.current = e.values;
      o(e => ({
        ...e
      }));
    } else {
      s._resetDefaultValues();
    }
  }, [s, e.values]);
  i.useEffect(() => {
    if (!s._state.mount) {
      s._setValid();
      s._state.mount = true;
    }
    if (s._state.watch) {
      s._state.watch = false;
      s._subjects.state.next({
        ...s._formState
      });
    }
    s._removeUnmounted();
  });
  t.current.formState = i.useMemo(() => O(a, s), [s, a]);
  return t.current;
}
var rt = (e, t, n) => {
  if (e && `reportValidity` in e) {
    let r = C(n, t);
    e.setCustomValidity(r && r.message || ``);
    e.reportValidity();
  }
};
var it = (e, t) => {
  for (let n in t.fields) {
    let r = t.fields[n];
    if (r && r.ref && `reportValidity` in r.ref) {
      rt(r.ref, n, e);
    } else if (r && r.refs) {
      r.refs.forEach(t => rt(t, n, e));
    }
  }
};
var at = (e, t) => {
  if (t.shouldUseNativeValidation) {
    it(e, t);
  }
  let n = {};
  for (let r in e) {
    let i = C(t.fields, r);
    let a = Object.assign(e[r] || {}, {
      ref: i && i.ref
    });
    if (ot(t.names || Object.keys(e), r)) {
      let e = Object.assign({}, C(n, r));
      E(e, `root`, a);
      E(n, r, e);
    } else {
      E(n, r, a);
    }
  }
  return n;
};
var ot = (e, t) => {
  let n = st(t);
  return e.some(e => st(e).match(`^${n}\\.\\d+`));
};
function st(e) {
  return e.replace(/\]|\[/g, ``);
}
function ct(e, t) {
  var n = {};
  for (; e.length;) {
    var r = e[0];
    var i = r.code;
    var a = r.message;
    var o = r.path.join(`.`);
    if (!n[o]) {
      if (`unionErrors` in r) {
        var s = r.unionErrors[0].errors[0];
        n[o] = {
          message: s.message,
          type: s.code
        };
      } else {
        n[o] = {
          message: a,
          type: i
        };
      }
    }
    if (`unionErrors` in r) {
      r.unionErrors.forEach(function (t) {
        return t.errors.forEach(function (t) {
          return e.push(t);
        });
      });
    }
    if (t) {
      var c = n[o].types;
      var l = c && c[r.code];
      n[o] = de(o, t, n, i, l ? [].concat(l, r.message) : r.message);
    }
    e.shift();
  }
  return n;
}
function lt(e, t, n = {}) {
  return function (r, i, a) {
    try {
      return Promise.resolve(function (i, o) {
        try {
          var s = Promise.resolve(e[n.mode === `sync` ? `parse` : `parseAsync`](r, t)).then(function (e) {
            if (a.shouldUseNativeValidation) {
              it({}, a);
            }
            return {
              errors: {},
              values: n.raw ? Object.assign({}, r) : e
            };
          });
        } catch (e) {
          return o(e);
        }
        if (s && s.then) {
          return s.then(undefined, o);
        } else {
          return s;
        }
      }(0, function (e) {
        if (function (e) {
          return Array.isArray(e?.errors);
        }(e)) {
          return {
            values: {},
            errors: at(ct(e.errors, !a.shouldUseNativeValidation && a.criteriaMode === `all`), a)
          };
        }
        throw e;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var B;
(function (e) {
  e.assertEqual = e => {};
  function t(e) {}
  e.assertIs = t;
  function n(e) {
    throw Error();
  }
  e.assertNever = n;
  e.arrayToEnum = e => {
    let t = {};
    for (let n of e) {
      t[n] = n;
    }
    return t;
  };
  e.getValidEnumValues = t => {
    let n = e.objectKeys(t).filter(e => typeof t[t[e]] != `number`);
    let r = {};
    for (let e of n) {
      r[e] = t[e];
    }
    return e.objectValues(r);
  };
  e.objectValues = t => e.objectKeys(t).map(function (e) {
    return t[e];
  });
  e.objectKeys = typeof Object.keys == `function` ? e => Object.keys(e) : e => {
    let t = [];
    for (let n in e) {
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        t.push(n);
      }
    }
    return t;
  };
  e.find = (e, t) => {
    for (let n of e) {
      if (t(n)) {
        return n;
      }
    }
  };
  e.isInteger = typeof Number.isInteger == `function` ? e => Number.isInteger(e) : e => typeof e == `number` && Number.isFinite(e) && Math.floor(e) === e;
  function r(e, t = ` | `) {
    return e.map(e => typeof e == `string` ? `'${e}'` : e).join(t);
  }
  e.joinValues = r;
  e.jsonStringifyReplacer = (e, t) => typeof t == `bigint` ? t.toString() : t;
})(B ||= {});
var ut;
(function (e) {
  e.mergeShapes = (e, t) => ({
    ...e,
    ...t
  });
})(ut ||= {});
var V = B.arrayToEnum([`string`, `nan`, `number`, `integer`, `float`, `boolean`, `date`, `bigint`, `symbol`, `function`, `undefined`, `null`, `array`, `object`, `unknown`, `promise`, `void`, `never`, `map`, `set`]);
var dt = e => {
  switch (typeof e) {
    case `undefined`:
      return V.undefined;
    case `string`:
      return V.string;
    case `number`:
      if (Number.isNaN(e)) {
        return V.nan;
      } else {
        return V.number;
      }
    case `boolean`:
      return V.boolean;
    case `function`:
      return V.function;
    case `bigint`:
      return V.bigint;
    case `symbol`:
      return V.symbol;
    case `object`:
      if (Array.isArray(e)) {
        return V.array;
      } else if (e === null) {
        return V.null;
      } else if (e.then && typeof e.then == `function` && e.catch && typeof e.catch == `function`) {
        return V.promise;
      } else if (typeof Map < `u` && e instanceof Map) {
        return V.map;
      } else if (typeof Set < `u` && e instanceof Set) {
        return V.set;
      } else if (typeof Date < `u` && e instanceof Date) {
        return V.date;
      } else {
        return V.object;
      }
    default:
      return V.unknown;
  }
};
var H = B.arrayToEnum([`invalid_type`, `invalid_literal`, `custom`, `invalid_union`, `invalid_union_discriminator`, `invalid_enum_value`, `unrecognized_keys`, `invalid_arguments`, `invalid_return_type`, `invalid_date`, `invalid_string`, `too_small`, `too_big`, `invalid_intersection_types`, `not_multiple_of`, `not_finite`]);
var U = class e extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super();
    this.issues = [];
    this.addIssue = e => {
      this.issues = [...this.issues, e];
    };
    this.addIssues = (e = []) => {
      this.issues = [...this.issues, ...e];
    };
    let t = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, t);
    } else {
      this.__proto__ = t;
    }
    this.name = `ZodError`;
    this.issues = e;
  }
  format(e) {
    let t = e || function (e) {
      return e.message;
    };
    let n = {
      _errors: []
    };
    let r = e => {
      for (let i of e.issues) {
        if (i.code === `invalid_union`) {
          i.unionErrors.map(r);
        } else if (i.code === `invalid_return_type`) {
          r(i.returnTypeError);
        } else if (i.code === `invalid_arguments`) {
          r(i.argumentsError);
        } else if (i.path.length === 0) {
          n._errors.push(t(i));
        } else {
          let e = n;
          let r = 0;
          while (r < i.path.length) {
            let n = i.path[r];
            if (r === i.path.length - 1) {
              e[n] = e[n] || {
                _errors: []
              };
              e[n]._errors.push(t(i));
            } else {
              e[n] = e[n] || {
                _errors: []
              };
            }
            e = e[n];
            r++;
          }
        }
      }
    };
    r(this);
    return n;
  }
  static assert(t) {
    if (!(t instanceof e)) {
      throw Error(`Not a ZodError: ${t}`);
    }
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, B.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = e => e.message) {
    let t = {};
    let n = [];
    for (let r of this.issues) {
      if (r.path.length > 0) {
        let n = r.path[0];
        t[n] = t[n] || [];
        t[n].push(e(r));
      } else {
        n.push(e(r));
      }
    }
    return {
      formErrors: n,
      fieldErrors: t
    };
  }
  get formErrors() {
    return this.flatten();
  }
};
U.create = e => new U(e);
var ft = (e, t) => {
  let n;
  switch (e.code) {
    case H.invalid_type:
      n = e.received === V.undefined ? `Required` : `Expected ${e.expected}, received ${e.received}`;
      break;
    case H.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, B.jsonStringifyReplacer)}`;
      break;
    case H.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${B.joinValues(e.keys, `, `)}`;
      break;
    case H.invalid_union:
      n = `Invalid input`;
      break;
    case H.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${B.joinValues(e.options)}`;
      break;
    case H.invalid_enum_value:
      n = `Invalid enum value. Expected ${B.joinValues(e.options)}, received '${e.received}'`;
      break;
    case H.invalid_arguments:
      n = `Invalid function arguments`;
      break;
    case H.invalid_return_type:
      n = `Invalid function return type`;
      break;
    case H.invalid_date:
      n = `Invalid date`;
      break;
    case H.invalid_string:
      if (typeof e.validation == `object`) {
        if (`includes` in e.validation) {
          n = `Invalid input: must include "${e.validation.includes}"`;
          if (typeof e.validation.position == `number`) {
            n = `${n} at one or more positions greater than or equal to ${e.validation.position}`;
          }
        } else if (`startsWith` in e.validation) {
          n = `Invalid input: must start with "${e.validation.startsWith}"`;
        } else if (`endsWith` in e.validation) {
          n = `Invalid input: must end with "${e.validation.endsWith}"`;
        } else {
          B.assertNever(e.validation);
        }
      } else {
        n = e.validation === `regex` ? `Invalid` : `Invalid ${e.validation}`;
      }
      break;
    case H.too_small:
      n = e.type === `array` ? `Array must contain ${e.exact ? `exactly` : e.inclusive ? `at least` : `more than`} ${e.minimum} element(s)` : e.type === `string` ? `String must contain ${e.exact ? `exactly` : e.inclusive ? `at least` : `over`} ${e.minimum} character(s)` : e.type === `number` || e.type === `bigint` ? `Number must be ${e.exact ? `exactly equal to ` : e.inclusive ? `greater than or equal to ` : `greater than `}${e.minimum}` : e.type === `date` ? `Date must be ${e.exact ? `exactly equal to ` : e.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(e.minimum))}` : `Invalid input`;
      break;
    case H.too_big:
      n = e.type === `array` ? `Array must contain ${e.exact ? `exactly` : e.inclusive ? `at most` : `less than`} ${e.maximum} element(s)` : e.type === `string` ? `String must contain ${e.exact ? `exactly` : e.inclusive ? `at most` : `under`} ${e.maximum} character(s)` : e.type === `number` ? `Number must be ${e.exact ? `exactly` : e.inclusive ? `less than or equal to` : `less than`} ${e.maximum}` : e.type === `bigint` ? `BigInt must be ${e.exact ? `exactly` : e.inclusive ? `less than or equal to` : `less than`} ${e.maximum}` : e.type === `date` ? `Date must be ${e.exact ? `exactly` : e.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(e.maximum))}` : `Invalid input`;
      break;
    case H.custom:
      n = `Invalid input`;
      break;
    case H.invalid_intersection_types:
      n = `Intersection results could not be merged`;
      break;
    case H.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case H.not_finite:
      n = `Number must be finite`;
      break;
    default:
      n = t.defaultError;
      B.assertNever(e);
  }
  return {
    message: n
  };
};
var pt = ft;
function mt() {
  return pt;
}
var ht = e => {
  let {
    data: t,
    path: n,
    errorMaps: r,
    issueData: i
  } = e;
  let a = [...n, ...(i.path || [])];
  let o = {
    ...i,
    path: a
  };
  if (i.message !== undefined) {
    return {
      ...i,
      path: a,
      message: i.message
    };
  }
  let s = ``;
  let c = r.filter(e => !!e).slice().reverse();
  for (let e of c) {
    s = e(o, {
      data: t,
      defaultError: s
    }).message;
  }
  return {
    ...i,
    path: a,
    message: s
  };
};
function W(e, t) {
  let n = mt();
  let r = ht({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [e.common.contextualErrorMap, e.schemaErrorMap, n, n === ft ? undefined : ft].filter(e => e)
  });
  e.common.issues.push(r);
}
var G = class e {
  constructor() {
    this.value = `valid`;
  }
  dirty() {
    if (this.value === `valid`) {
      this.value = `dirty`;
    }
  }
  abort() {
    if (this.value !== `aborted`) {
      this.value = `aborted`;
    }
  }
  static mergeArray(e, t) {
    let n = [];
    for (let r of t) {
      if (r.status === `aborted`) {
        return K;
      }
      if (r.status === `dirty`) {
        e.dirty();
      }
      n.push(r.value);
    }
    return {
      status: e.value,
      value: n
    };
  }
  static async mergeObjectAsync(t, n) {
    let r = [];
    for (let e of n) {
      let t = await e.key;
      let n = await e.value;
      r.push({
        key: t,
        value: n
      });
    }
    return e.mergeObjectSync(t, r);
  }
  static mergeObjectSync(e, t) {
    let n = {};
    for (let r of t) {
      let {
        key: t,
        value: i
      } = r;
      if (t.status === `aborted` || i.status === `aborted`) {
        return K;
      }
      if (t.status === `dirty`) {
        e.dirty();
      }
      if (i.status === `dirty`) {
        e.dirty();
      }
      if (t.value !== `__proto__` && (i.value !== undefined || r.alwaysSet)) {
        n[t.value] = i.value;
      }
    }
    return {
      status: e.value,
      value: n
    };
  }
};
var K = Object.freeze({
  status: `aborted`
});
var gt = e => ({
  status: `dirty`,
  value: e
});
var q = e => ({
  status: `valid`,
  value: e
});
var _t = e => e.status === `aborted`;
var vt = e => e.status === `dirty`;
var yt = e => e.status === `valid`;
var bt = e => typeof Promise < `u` && e instanceof Promise;
var J;
(function (e) {
  e.errToObj = e => typeof e == `string` ? {
    message: e
  } : e || {};
  e.toString = e => typeof e == `string` ? e : e?.message;
})(J ||= {});
var Y = class {
  constructor(e, t, n, r) {
    this._cachedPath = [];
    this.parent = e;
    this.data = t;
    this._path = n;
    this._key = r;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (Array.isArray(this._key)) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
};
var xt = (e, t) => {
  if (yt(t)) {
    return {
      success: true,
      data: t.value
    };
  }
  if (!e.common.issues.length) {
    throw Error(`Validation failed but no issues detected.`);
  }
  return {
    success: false,
    get error() {
      if (this._error) {
        return this._error;
      }
      let t = new U(e.common.issues);
      this._error = t;
      return this._error;
    }
  };
};
function X(e) {
  if (!e) {
    return {};
  }
  let {
    errorMap: t,
    invalid_type_error: n,
    required_error: r,
    description: i
  } = e;
  if (t && (n || r)) {
    throw Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (t) {
    return {
      errorMap: t,
      description: i
    };
  } else {
    return {
      errorMap: (t, i) => {
        let {
          message: a
        } = e;
        if (t.code === `invalid_enum_value`) {
          return {
            message: a ?? i.defaultError
          };
        } else if (i.data === undefined) {
          return {
            message: a ?? r ?? i.defaultError
          };
        } else if (t.code === `invalid_type`) {
          return {
            message: a ?? n ?? i.defaultError
          };
        } else {
          return {
            message: i.defaultError
          };
        }
      },
      description: i
    };
  }
}
var Z = class {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return dt(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: dt(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new G(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: dt(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    let t = this._parse(e);
    if (bt(t)) {
      throw Error(`Synchronous parse encountered promise.`);
    }
    return t;
  }
  _parseAsync(e) {
    let t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    let n = this.safeParse(e, t);
    if (n.success) {
      return n.data;
    }
    throw n.error;
  }
  safeParse(e, t) {
    let n = {
      common: {
        issues: [],
        async: t?.async ?? false,
        contextualErrorMap: t?.errorMap
      },
      path: t?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: dt(e)
    };
    return xt(n, this._parseSync({
      data: e,
      path: n.path,
      parent: n
    }));
  }
  "~validate"(e) {
    let t = {
      common: {
        issues: [],
        async: !!this[`~standard`].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: dt(e)
    };
    if (!this[`~standard`].async) {
      try {
        let n = this._parseSync({
          data: e,
          path: [],
          parent: t
        });
        if (yt(n)) {
          return {
            value: n.value
          };
        } else {
          return {
            issues: t.common.issues
          };
        }
      } catch (e) {
        if (e?.message?.toLowerCase()?.includes(`encountered`)) {
          this[`~standard`].async = true;
        }
        t.common = {
          issues: [],
          async: true
        };
      }
    }
    return this._parseAsync({
      data: e,
      path: [],
      parent: t
    }).then(e => yt(e) ? {
      value: e.value
    } : {
      issues: t.common.issues
    });
  }
  async parseAsync(e, t) {
    let n = await this.safeParseAsync(e, t);
    if (n.success) {
      return n.data;
    }
    throw n.error;
  }
  async safeParseAsync(e, t) {
    let n = {
      common: {
        issues: [],
        contextualErrorMap: t?.errorMap,
        async: true
      },
      path: t?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: dt(e)
    };
    let r = this._parse({
      data: e,
      path: n.path,
      parent: n
    });
    return xt(n, await (bt(r) ? r : Promise.resolve(r)));
  }
  refine(e, t) {
    let n = e => typeof t == `string` || t === undefined ? {
      message: t
    } : typeof t == `function` ? t(e) : t;
    return this._refinement((t, r) => {
      let i = e(t);
      let a = () => r.addIssue({
        code: H.custom,
        ...n(t)
      });
      if (typeof Promise < `u` && i instanceof Promise) {
        return i.then(e => e ? true : (a(), false));
      } else if (i) {
        return true;
      } else {
        a();
        return false;
      }
    });
  }
  refinement(e, t) {
    return this._refinement((n, r) => e(n) ? true : (r.addIssue(typeof t == `function` ? t(n, r) : t), false));
  }
  _refinement(e) {
    return new wn({
      schema: this,
      typeName: $.ZodEffects,
      effect: {
        type: `refinement`,
        refinement: e
      }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync;
    this._def = e;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
    this[`~standard`] = {
      version: 1,
      vendor: `zod`,
      validate: e => this[`~validate`](e)
    };
  }
  optional() {
    return Tn.create(this, this._def);
  }
  nullable() {
    return En.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return on.create(this);
  }
  promise() {
    return Cn.create(this, this._def);
  }
  or(e) {
    return cn.create([this, e], this._def);
  }
  and(e) {
    return fn.create(this, e, this._def);
  }
  transform(e) {
    return new wn({
      ...X(this._def),
      schema: this,
      typeName: $.ZodEffects,
      effect: {
        type: `transform`,
        transform: e
      }
    });
  }
  default(e) {
    let t = typeof e == `function` ? e : () => e;
    return new Dn({
      ...X(this._def),
      innerType: this,
      defaultValue: t,
      typeName: $.ZodDefault
    });
  }
  brand() {
    return new An({
      typeName: $.ZodBranded,
      type: this,
      ...X(this._def)
    });
  }
  catch(e) {
    let t = typeof e == `function` ? e : () => e;
    return new On({
      ...X(this._def),
      innerType: this,
      catchValue: t,
      typeName: $.ZodCatch
    });
  }
  describe(e) {
    let t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return jn.create(this, e);
  }
  readonly() {
    return Mn.create(this);
  }
  isOptional() {
    return this.safeParse(undefined).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
var St = /^c[^\s-]{8,}$/i;
var Ct = /^[0-9a-z]+$/;
var wt = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
var Tt = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var Et = /^[a-z0-9_-]{21}$/i;
var Dt = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
var Ot = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
var kt = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var At = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
var jt;
var Mt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
var Nt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
var Pt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
var Ft = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
var It = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
var Lt = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
var Rt = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
var zt = RegExp(`^${Rt}$`);
function Bt(e) {
  let t = `[0-5]\\d`;
  if (e.precision) {
    t = `${t}\\.\\d{${e.precision}}`;
  } else {
    e.precision ?? (t = `${t}(\\.\\d+)?`);
  }
  let n = e.precision ? `+` : `?`;
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${n}`;
}
function Vt(e) {
  return RegExp(`^${Bt(e)}$`);
}
function Ht(e) {
  let t = `${Rt}T${Bt(e)}`;
  let n = [];
  n.push(e.local ? `Z?` : `Z`);
  if (e.offset) {
    n.push(`([+-]\\d{2}:?\\d{2})`);
  }
  t = `${t}(${n.join(`|`)})`;
  return RegExp(`^${t}$`);
}
function Ut(e, t) {
  return (t === `v4` || !t) && !!Mt.test(e) || (t === `v6` || !t) && !!Pt.test(e);
}
function Wt(e, t) {
  if (!Dt.test(e)) {
    return false;
  }
  try {
    let [n] = e.split(`.`);
    if (!n) {
      return false;
    }
    let r = n.replace(/-/g, `+`).replace(/_/g, `/`).padEnd(n.length + (4 - n.length % 4) % 4, `=`);
    let i = JSON.parse(atob(r));
    return typeof i == `object` && !!i && (!(`typ` in i) || i?.typ === `JWT`) && !!i.alg && (!t || i.alg === t);
  } catch {
    return false;
  }
}
function Gt(e, t) {
  return (t === `v4` || !t) && !!Nt.test(e) || (t === `v6` || !t) && !!Ft.test(e);
}
var Kt = class e extends Z {
  _parse(e) {
    if (this._def.coerce) {
      e.data = String(e.data);
    }
    if (this._getType(e) !== V.string) {
      let t = this._getOrReturnCtx(e);
      W(t, {
        code: H.invalid_type,
        expected: V.string,
        received: t.parsedType
      });
      return K;
    }
    let t = new G();
    let n;
    for (let r of this._def.checks) {
      if (r.kind === `min`) {
        if (e.data.length < r.value) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            code: H.too_small,
            minimum: r.value,
            type: `string`,
            inclusive: true,
            exact: false,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `max`) {
        if (e.data.length > r.value) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            code: H.too_big,
            maximum: r.value,
            type: `string`,
            inclusive: true,
            exact: false,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `length`) {
        let i = e.data.length > r.value;
        let a = e.data.length < r.value;
        if (i || a) {
          n = this._getOrReturnCtx(e, n);
          if (i) {
            W(n, {
              code: H.too_big,
              maximum: r.value,
              type: `string`,
              inclusive: true,
              exact: true,
              message: r.message
            });
          } else if (a) {
            W(n, {
              code: H.too_small,
              minimum: r.value,
              type: `string`,
              inclusive: true,
              exact: true,
              message: r.message
            });
          }
          t.dirty();
        }
      } else if (r.kind === `email`) {
        if (!kt.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `email`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `emoji`) {
        jt ||= new RegExp(At, `u`);
        if (!jt.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `emoji`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `uuid`) {
        if (!Tt.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `uuid`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `nanoid`) {
        if (!Et.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `nanoid`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `cuid`) {
        if (!St.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `cuid`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `cuid2`) {
        if (!Ct.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `cuid2`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `ulid`) {
        if (!wt.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `ulid`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `url`) {
        try {
          new URL(e.data);
        } catch {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `url`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `regex`) {
        r.regex.lastIndex = 0;
        if (!r.regex.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `regex`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `trim`) {
        e.data = e.data.trim();
      } else if (r.kind === `includes`) {
        if (!e.data.includes(r.value, r.position)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            code: H.invalid_string,
            validation: {
              includes: r.value,
              position: r.position
            },
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `toLowerCase`) {
        e.data = e.data.toLowerCase();
      } else if (r.kind === `toUpperCase`) {
        e.data = e.data.toUpperCase();
      } else if (r.kind === `startsWith`) {
        if (!e.data.startsWith(r.value)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            code: H.invalid_string,
            validation: {
              startsWith: r.value
            },
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `endsWith`) {
        if (!e.data.endsWith(r.value)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            code: H.invalid_string,
            validation: {
              endsWith: r.value
            },
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `datetime`) {
        if (!Ht(r).test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            code: H.invalid_string,
            validation: `datetime`,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `date`) {
        if (!zt.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            code: H.invalid_string,
            validation: `date`,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `time`) {
        if (!Vt(r).test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            code: H.invalid_string,
            validation: `time`,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `duration`) {
        if (!Ot.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `duration`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `ip`) {
        if (!Ut(e.data, r.version)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `ip`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `jwt`) {
        if (!Wt(e.data, r.alg)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `jwt`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `cidr`) {
        if (!Gt(e.data, r.version)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `cidr`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `base64`) {
        if (!It.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `base64`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else if (r.kind === `base64url`) {
        if (!Lt.test(e.data)) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            validation: `base64url`,
            code: H.invalid_string,
            message: r.message
          });
          t.dirty();
        }
      } else {
        B.assertNever(r);
      }
    }
    return {
      status: t.value,
      value: e.data
    };
  }
  _regex(e, t, n) {
    return this.refinement(t => e.test(t), {
      validation: t,
      code: H.invalid_string,
      ...J.errToObj(n)
    });
  }
  _addCheck(t) {
    return new e({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(e) {
    return this._addCheck({
      kind: `email`,
      ...J.errToObj(e)
    });
  }
  url(e) {
    return this._addCheck({
      kind: `url`,
      ...J.errToObj(e)
    });
  }
  emoji(e) {
    return this._addCheck({
      kind: `emoji`,
      ...J.errToObj(e)
    });
  }
  uuid(e) {
    return this._addCheck({
      kind: `uuid`,
      ...J.errToObj(e)
    });
  }
  nanoid(e) {
    return this._addCheck({
      kind: `nanoid`,
      ...J.errToObj(e)
    });
  }
  cuid(e) {
    return this._addCheck({
      kind: `cuid`,
      ...J.errToObj(e)
    });
  }
  cuid2(e) {
    return this._addCheck({
      kind: `cuid2`,
      ...J.errToObj(e)
    });
  }
  ulid(e) {
    return this._addCheck({
      kind: `ulid`,
      ...J.errToObj(e)
    });
  }
  base64(e) {
    return this._addCheck({
      kind: `base64`,
      ...J.errToObj(e)
    });
  }
  base64url(e) {
    return this._addCheck({
      kind: `base64url`,
      ...J.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({
      kind: `jwt`,
      ...J.errToObj(e)
    });
  }
  ip(e) {
    return this._addCheck({
      kind: `ip`,
      ...J.errToObj(e)
    });
  }
  cidr(e) {
    return this._addCheck({
      kind: `cidr`,
      ...J.errToObj(e)
    });
  }
  datetime(e) {
    if (typeof e == `string`) {
      return this._addCheck({
        kind: `datetime`,
        precision: null,
        offset: false,
        local: false,
        message: e
      });
    } else {
      return this._addCheck({
        kind: `datetime`,
        precision: e?.precision === undefined ? null : e?.precision,
        offset: e?.offset ?? false,
        local: e?.local ?? false,
        ...J.errToObj(e?.message)
      });
    }
  }
  date(e) {
    return this._addCheck({
      kind: `date`,
      message: e
    });
  }
  time(e) {
    if (typeof e == `string`) {
      return this._addCheck({
        kind: `time`,
        precision: null,
        message: e
      });
    } else {
      return this._addCheck({
        kind: `time`,
        precision: e?.precision === undefined ? null : e?.precision,
        ...J.errToObj(e?.message)
      });
    }
  }
  duration(e) {
    return this._addCheck({
      kind: `duration`,
      ...J.errToObj(e)
    });
  }
  regex(e, t) {
    return this._addCheck({
      kind: `regex`,
      regex: e,
      ...J.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: `includes`,
      value: e,
      position: t?.position,
      ...J.errToObj(t?.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: `startsWith`,
      value: e,
      ...J.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: `endsWith`,
      value: e,
      ...J.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: `min`,
      value: e,
      ...J.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: `max`,
      value: e,
      ...J.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: `length`,
      value: e,
      ...J.errToObj(t)
    });
  }
  nonempty(e) {
    return this.min(1, J.errToObj(e));
  }
  trim() {
    return new e({
      ...this._def,
      checks: [...this._def.checks, {
        kind: `trim`
      }]
    });
  }
  toLowerCase() {
    return new e({
      ...this._def,
      checks: [...this._def.checks, {
        kind: `toLowerCase`
      }]
    });
  }
  toUpperCase() {
    return new e({
      ...this._def,
      checks: [...this._def.checks, {
        kind: `toUpperCase`
      }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find(e => e.kind === `datetime`);
  }
  get isDate() {
    return !!this._def.checks.find(e => e.kind === `date`);
  }
  get isTime() {
    return !!this._def.checks.find(e => e.kind === `time`);
  }
  get isDuration() {
    return !!this._def.checks.find(e => e.kind === `duration`);
  }
  get isEmail() {
    return !!this._def.checks.find(e => e.kind === `email`);
  }
  get isURL() {
    return !!this._def.checks.find(e => e.kind === `url`);
  }
  get isEmoji() {
    return !!this._def.checks.find(e => e.kind === `emoji`);
  }
  get isUUID() {
    return !!this._def.checks.find(e => e.kind === `uuid`);
  }
  get isNANOID() {
    return !!this._def.checks.find(e => e.kind === `nanoid`);
  }
  get isCUID() {
    return !!this._def.checks.find(e => e.kind === `cuid`);
  }
  get isCUID2() {
    return !!this._def.checks.find(e => e.kind === `cuid2`);
  }
  get isULID() {
    return !!this._def.checks.find(e => e.kind === `ulid`);
  }
  get isIP() {
    return !!this._def.checks.find(e => e.kind === `ip`);
  }
  get isCIDR() {
    return !!this._def.checks.find(e => e.kind === `cidr`);
  }
  get isBase64() {
    return !!this._def.checks.find(e => e.kind === `base64`);
  }
  get isBase64url() {
    return !!this._def.checks.find(e => e.kind === `base64url`);
  }
  get minLength() {
    let e = null;
    for (let t of this._def.checks) {
      if (t.kind === `min` && (e === null || t.value > e)) {
        e = t.value;
      }
    }
    return e;
  }
  get maxLength() {
    let e = null;
    for (let t of this._def.checks) {
      if (t.kind === `max` && (e === null || t.value < e)) {
        e = t.value;
      }
    }
    return e;
  }
};
Kt.create = e => new Kt({
  checks: [],
  typeName: $.ZodString,
  coerce: e?.coerce ?? false,
  ...X(e)
});
function qt(e, t) {
  let n = (e.toString().split(`.`)[1] || ``).length;
  let r = (t.toString().split(`.`)[1] || ``).length;
  let i = n > r ? n : r;
  return Number.parseInt(e.toFixed(i).replace(`.`, ``)) % Number.parseInt(t.toFixed(i).replace(`.`, ``)) / 10 ** i;
}
var Jt = class e extends Z {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce) {
      e.data = Number(e.data);
    }
    if (this._getType(e) !== V.number) {
      let t = this._getOrReturnCtx(e);
      W(t, {
        code: H.invalid_type,
        expected: V.number,
        received: t.parsedType
      });
      return K;
    }
    let t;
    let n = new G();
    for (let r of this._def.checks) {
      if (r.kind === `int`) {
        if (!B.isInteger(e.data)) {
          t = this._getOrReturnCtx(e, t);
          W(t, {
            code: H.invalid_type,
            expected: `integer`,
            received: `float`,
            message: r.message
          });
          n.dirty();
        }
      } else if (r.kind === `min`) {
        if (r.inclusive ? e.data < r.value : e.data <= r.value) {
          t = this._getOrReturnCtx(e, t);
          W(t, {
            code: H.too_small,
            minimum: r.value,
            type: `number`,
            inclusive: r.inclusive,
            exact: false,
            message: r.message
          });
          n.dirty();
        }
      } else if (r.kind === `max`) {
        if (r.inclusive ? e.data > r.value : e.data >= r.value) {
          t = this._getOrReturnCtx(e, t);
          W(t, {
            code: H.too_big,
            maximum: r.value,
            type: `number`,
            inclusive: r.inclusive,
            exact: false,
            message: r.message
          });
          n.dirty();
        }
      } else if (r.kind === `multipleOf`) {
        if (qt(e.data, r.value) !== 0) {
          t = this._getOrReturnCtx(e, t);
          W(t, {
            code: H.not_multiple_of,
            multipleOf: r.value,
            message: r.message
          });
          n.dirty();
        }
      } else if (r.kind === `finite`) {
        if (!Number.isFinite(e.data)) {
          t = this._getOrReturnCtx(e, t);
          W(t, {
            code: H.not_finite,
            message: r.message
          });
          n.dirty();
        }
      } else {
        B.assertNever(r);
      }
    }
    return {
      status: n.value,
      value: e.data
    };
  }
  gte(e, t) {
    return this.setLimit(`min`, e, true, J.toString(t));
  }
  gt(e, t) {
    return this.setLimit(`min`, e, false, J.toString(t));
  }
  lte(e, t) {
    return this.setLimit(`max`, e, true, J.toString(t));
  }
  lt(e, t) {
    return this.setLimit(`max`, e, false, J.toString(t));
  }
  setLimit(t, n, r, i) {
    return new e({
      ...this._def,
      checks: [...this._def.checks, {
        kind: t,
        value: n,
        inclusive: r,
        message: J.toString(i)
      }]
    });
  }
  _addCheck(t) {
    return new e({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(e) {
    return this._addCheck({
      kind: `int`,
      message: J.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: `min`,
      value: 0,
      inclusive: false,
      message: J.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: `max`,
      value: 0,
      inclusive: false,
      message: J.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: `max`,
      value: 0,
      inclusive: true,
      message: J.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: `min`,
      value: 0,
      inclusive: true,
      message: J.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: `multipleOf`,
      value: e,
      message: J.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: `finite`,
      message: J.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: `min`,
      inclusive: true,
      value: -9007199254740991,
      message: J.toString(e)
    })._addCheck({
      kind: `max`,
      inclusive: true,
      value: 9007199254740991,
      message: J.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (let t of this._def.checks) {
      if (t.kind === `min` && (e === null || t.value > e)) {
        e = t.value;
      }
    }
    return e;
  }
  get maxValue() {
    let e = null;
    for (let t of this._def.checks) {
      if (t.kind === `max` && (e === null || t.value < e)) {
        e = t.value;
      }
    }
    return e;
  }
  get isInt() {
    return !!this._def.checks.find(e => e.kind === `int` || e.kind === `multipleOf` && B.isInteger(e.value));
  }
  get isFinite() {
    let e = null;
    let t = null;
    for (let n of this._def.checks) {
      if (n.kind === `finite` || n.kind === `int` || n.kind === `multipleOf`) {
        return true;
      } else if (n.kind === `min`) {
        if (t === null || n.value > t) {
          t = n.value;
        }
      } else if (n.kind === `max` && (e === null || n.value < e)) {
        e = n.value;
      }
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
};
Jt.create = e => new Jt({
  checks: [],
  typeName: $.ZodNumber,
  coerce: e?.coerce || false,
  ...X(e)
});
var Yt = class e extends Z {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce) {
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    }
    if (this._getType(e) !== V.bigint) {
      return this._getInvalidInput(e);
    }
    let t;
    let n = new G();
    for (let r of this._def.checks) {
      if (r.kind === `min`) {
        if (r.inclusive ? e.data < r.value : e.data <= r.value) {
          t = this._getOrReturnCtx(e, t);
          W(t, {
            code: H.too_small,
            type: `bigint`,
            minimum: r.value,
            inclusive: r.inclusive,
            message: r.message
          });
          n.dirty();
        }
      } else if (r.kind === `max`) {
        if (r.inclusive ? e.data > r.value : e.data >= r.value) {
          t = this._getOrReturnCtx(e, t);
          W(t, {
            code: H.too_big,
            type: `bigint`,
            maximum: r.value,
            inclusive: r.inclusive,
            message: r.message
          });
          n.dirty();
        }
      } else if (r.kind === `multipleOf`) {
        if (e.data % r.value !== BigInt(0)) {
          t = this._getOrReturnCtx(e, t);
          W(t, {
            code: H.not_multiple_of,
            multipleOf: r.value,
            message: r.message
          });
          n.dirty();
        }
      } else {
        B.assertNever(r);
      }
    }
    return {
      status: n.value,
      value: e.data
    };
  }
  _getInvalidInput(e) {
    let t = this._getOrReturnCtx(e);
    W(t, {
      code: H.invalid_type,
      expected: V.bigint,
      received: t.parsedType
    });
    return K;
  }
  gte(e, t) {
    return this.setLimit(`min`, e, true, J.toString(t));
  }
  gt(e, t) {
    return this.setLimit(`min`, e, false, J.toString(t));
  }
  lte(e, t) {
    return this.setLimit(`max`, e, true, J.toString(t));
  }
  lt(e, t) {
    return this.setLimit(`max`, e, false, J.toString(t));
  }
  setLimit(t, n, r, i) {
    return new e({
      ...this._def,
      checks: [...this._def.checks, {
        kind: t,
        value: n,
        inclusive: r,
        message: J.toString(i)
      }]
    });
  }
  _addCheck(t) {
    return new e({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: `min`,
      value: BigInt(0),
      inclusive: false,
      message: J.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: `max`,
      value: BigInt(0),
      inclusive: false,
      message: J.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: `max`,
      value: BigInt(0),
      inclusive: true,
      message: J.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: `min`,
      value: BigInt(0),
      inclusive: true,
      message: J.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: `multipleOf`,
      value: e,
      message: J.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (let t of this._def.checks) {
      if (t.kind === `min` && (e === null || t.value > e)) {
        e = t.value;
      }
    }
    return e;
  }
  get maxValue() {
    let e = null;
    for (let t of this._def.checks) {
      if (t.kind === `max` && (e === null || t.value < e)) {
        e = t.value;
      }
    }
    return e;
  }
};
Yt.create = e => new Yt({
  checks: [],
  typeName: $.ZodBigInt,
  coerce: e?.coerce ?? false,
  ...X(e)
});
var Xt = class extends Z {
  _parse(e) {
    if (this._def.coerce) {
      e.data = !!e.data;
    }
    if (this._getType(e) !== V.boolean) {
      let t = this._getOrReturnCtx(e);
      W(t, {
        code: H.invalid_type,
        expected: V.boolean,
        received: t.parsedType
      });
      return K;
    }
    return q(e.data);
  }
};
Xt.create = e => new Xt({
  typeName: $.ZodBoolean,
  coerce: e?.coerce || false,
  ...X(e)
});
var Zt = class e extends Z {
  _parse(e) {
    if (this._def.coerce) {
      e.data = new Date(e.data);
    }
    if (this._getType(e) !== V.date) {
      let t = this._getOrReturnCtx(e);
      W(t, {
        code: H.invalid_type,
        expected: V.date,
        received: t.parsedType
      });
      return K;
    }
    if (Number.isNaN(e.data.getTime())) {
      W(this._getOrReturnCtx(e), {
        code: H.invalid_date
      });
      return K;
    }
    let t = new G();
    let n;
    for (let r of this._def.checks) {
      if (r.kind === `min`) {
        if (e.data.getTime() < r.value) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            code: H.too_small,
            message: r.message,
            inclusive: true,
            exact: false,
            minimum: r.value,
            type: `date`
          });
          t.dirty();
        }
      } else if (r.kind === `max`) {
        if (e.data.getTime() > r.value) {
          n = this._getOrReturnCtx(e, n);
          W(n, {
            code: H.too_big,
            message: r.message,
            inclusive: true,
            exact: false,
            maximum: r.value,
            type: `date`
          });
          t.dirty();
        }
      } else {
        B.assertNever(r);
      }
    }
    return {
      status: t.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(t) {
    return new e({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: `min`,
      value: e.getTime(),
      message: J.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: `max`,
      value: e.getTime(),
      message: J.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (let t of this._def.checks) {
      if (t.kind === `min` && (e === null || t.value > e)) {
        e = t.value;
      }
    }
    if (e == null) {
      return null;
    } else {
      return new Date(e);
    }
  }
  get maxDate() {
    let e = null;
    for (let t of this._def.checks) {
      if (t.kind === `max` && (e === null || t.value < e)) {
        e = t.value;
      }
    }
    if (e == null) {
      return null;
    } else {
      return new Date(e);
    }
  }
};
Zt.create = e => new Zt({
  checks: [],
  coerce: e?.coerce || false,
  typeName: $.ZodDate,
  ...X(e)
});
var Qt = class extends Z {
  _parse(e) {
    if (this._getType(e) !== V.symbol) {
      let t = this._getOrReturnCtx(e);
      W(t, {
        code: H.invalid_type,
        expected: V.symbol,
        received: t.parsedType
      });
      return K;
    }
    return q(e.data);
  }
};
Qt.create = e => new Qt({
  typeName: $.ZodSymbol,
  ...X(e)
});
var $t = class extends Z {
  _parse(e) {
    if (this._getType(e) !== V.undefined) {
      let t = this._getOrReturnCtx(e);
      W(t, {
        code: H.invalid_type,
        expected: V.undefined,
        received: t.parsedType
      });
      return K;
    }
    return q(e.data);
  }
};
$t.create = e => new $t({
  typeName: $.ZodUndefined,
  ...X(e)
});
var en = class extends Z {
  _parse(e) {
    if (this._getType(e) !== V.null) {
      let t = this._getOrReturnCtx(e);
      W(t, {
        code: H.invalid_type,
        expected: V.null,
        received: t.parsedType
      });
      return K;
    }
    return q(e.data);
  }
};
en.create = e => new en({
  typeName: $.ZodNull,
  ...X(e)
});
var tn = class extends Z {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(e) {
    return q(e.data);
  }
};
tn.create = e => new tn({
  typeName: $.ZodAny,
  ...X(e)
});
var nn = class extends Z {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(e) {
    return q(e.data);
  }
};
nn.create = e => new nn({
  typeName: $.ZodUnknown,
  ...X(e)
});
var rn = class extends Z {
  _parse(e) {
    let t = this._getOrReturnCtx(e);
    W(t, {
      code: H.invalid_type,
      expected: V.never,
      received: t.parsedType
    });
    return K;
  }
};
rn.create = e => new rn({
  typeName: $.ZodNever,
  ...X(e)
});
var an = class extends Z {
  _parse(e) {
    if (this._getType(e) !== V.undefined) {
      let t = this._getOrReturnCtx(e);
      W(t, {
        code: H.invalid_type,
        expected: V.void,
        received: t.parsedType
      });
      return K;
    }
    return q(e.data);
  }
};
an.create = e => new an({
  typeName: $.ZodVoid,
  ...X(e)
});
var on = class e extends Z {
  _parse(e) {
    let {
      ctx: t,
      status: n
    } = this._processInputParams(e);
    let r = this._def;
    if (t.parsedType !== V.array) {
      W(t, {
        code: H.invalid_type,
        expected: V.array,
        received: t.parsedType
      });
      return K;
    }
    if (r.exactLength !== null) {
      let e = t.data.length > r.exactLength.value;
      let i = t.data.length < r.exactLength.value;
      if (e || i) {
        W(t, {
          code: e ? H.too_big : H.too_small,
          minimum: i ? r.exactLength.value : undefined,
          maximum: e ? r.exactLength.value : undefined,
          type: `array`,
          inclusive: true,
          exact: true,
          message: r.exactLength.message
        });
        n.dirty();
      }
    }
    if (r.minLength !== null && t.data.length < r.minLength.value) {
      W(t, {
        code: H.too_small,
        minimum: r.minLength.value,
        type: `array`,
        inclusive: true,
        exact: false,
        message: r.minLength.message
      });
      n.dirty();
    }
    if (r.maxLength !== null && t.data.length > r.maxLength.value) {
      W(t, {
        code: H.too_big,
        maximum: r.maxLength.value,
        type: `array`,
        inclusive: true,
        exact: false,
        message: r.maxLength.message
      });
      n.dirty();
    }
    if (t.common.async) {
      return Promise.all([...t.data].map((e, n) => r.type._parseAsync(new Y(t, e, t.path, n)))).then(e => G.mergeArray(n, e));
    }
    let i = [...t.data].map((e, n) => r.type._parseSync(new Y(t, e, t.path, n)));
    return G.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new e({
      ...this._def,
      minLength: {
        value: t,
        message: J.toString(n)
      }
    });
  }
  max(t, n) {
    return new e({
      ...this._def,
      maxLength: {
        value: t,
        message: J.toString(n)
      }
    });
  }
  length(t, n) {
    return new e({
      ...this._def,
      exactLength: {
        value: t,
        message: J.toString(n)
      }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
on.create = (e, t) => new on({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: $.ZodArray,
  ...X(t)
});
function sn(e) {
  if (e instanceof Q) {
    let t = {};
    for (let n in e.shape) {
      let r = e.shape[n];
      t[n] = Tn.create(sn(r));
    }
    return new Q({
      ...e._def,
      shape: () => t
    });
  }
  if (e instanceof on) {
    return new on({
      ...e._def,
      type: sn(e.element)
    });
  } else if (e instanceof Tn) {
    return Tn.create(sn(e.unwrap()));
  } else if (e instanceof En) {
    return En.create(sn(e.unwrap()));
  } else if (e instanceof pn) {
    return pn.create(e.items.map(e => sn(e)));
  } else {
    return e;
  }
}
var Q = class e extends Z {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) {
      return this._cached;
    }
    let e = this._def.shape();
    let t = B.objectKeys(e);
    this._cached = {
      shape: e,
      keys: t
    };
    return this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== V.object) {
      let t = this._getOrReturnCtx(e);
      W(t, {
        code: H.invalid_type,
        expected: V.object,
        received: t.parsedType
      });
      return K;
    }
    let {
      status: t,
      ctx: n
    } = this._processInputParams(e);
    let {
      shape: r,
      keys: i
    } = this._getCached();
    let a = [];
    if (!(this._def.catchall instanceof rn) || this._def.unknownKeys !== `strip`) {
      for (let e in n.data) {
        if (!i.includes(e)) {
          a.push(e);
        }
      }
    }
    let o = [];
    for (let e of i) {
      let t = r[e];
      let i = n.data[e];
      o.push({
        key: {
          status: `valid`,
          value: e
        },
        value: t._parse(new Y(n, i, n.path, e)),
        alwaysSet: e in n.data
      });
    }
    if (this._def.catchall instanceof rn) {
      let e = this._def.unknownKeys;
      if (e === `passthrough`) {
        for (let e of a) {
          o.push({
            key: {
              status: `valid`,
              value: e
            },
            value: {
              status: `valid`,
              value: n.data[e]
            }
          });
        }
      } else if (e === `strict`) {
        if (a.length > 0) {
          W(n, {
            code: H.unrecognized_keys,
            keys: a
          });
          t.dirty();
        }
      } else if (e !== `strip`) {
        throw Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      let e = this._def.catchall;
      for (let t of a) {
        let r = n.data[t];
        o.push({
          key: {
            status: `valid`,
            value: t
          },
          value: e._parse(new Y(n, r, n.path, t)),
          alwaysSet: t in n.data
        });
      }
    }
    if (n.common.async) {
      return Promise.resolve().then(async () => {
        let e = [];
        for (let t of o) {
          let n = await t.key;
          let r = await t.value;
          e.push({
            key: n,
            value: r,
            alwaysSet: t.alwaysSet
          });
        }
        return e;
      }).then(e => G.mergeObjectSync(t, e));
    } else {
      return G.mergeObjectSync(t, o);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    J.errToObj;
    return new e({
      ...this._def,
      unknownKeys: `strict`,
      ...(t === undefined ? {} : {
        errorMap: (e, n) => {
          let r = this._def.errorMap?.(e, n).message ?? n.defaultError;
          if (e.code === `unrecognized_keys`) {
            return {
              message: J.errToObj(t).message ?? r
            };
          } else {
            return {
              message: r
            };
          }
        }
      })
    });
  }
  strip() {
    return new e({
      ...this._def,
      unknownKeys: `strip`
    });
  }
  passthrough() {
    return new e({
      ...this._def,
      unknownKeys: `passthrough`
    });
  }
  extend(t) {
    return new e({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  merge(t) {
    return new e({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: $.ZodObject
    });
  }
  setKey(e, t) {
    return this.augment({
      [e]: t
    });
  }
  catchall(t) {
    return new e({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    let n = {};
    for (let e of B.objectKeys(t)) {
      if (t[e] && this.shape[e]) {
        n[e] = this.shape[e];
      }
    }
    return new e({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    let n = {};
    for (let e of B.objectKeys(this.shape)) {
      if (!t[e]) {
        n[e] = this.shape[e];
      }
    }
    return new e({
      ...this._def,
      shape: () => n
    });
  }
  deepPartial() {
    return sn(this);
  }
  partial(t) {
    let n = {};
    for (let e of B.objectKeys(this.shape)) {
      let r = this.shape[e];
      n[e] = t && !t[e] ? r : r.optional();
    }
    return new e({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    let n = {};
    for (let e of B.objectKeys(this.shape)) {
      if (t && !t[e]) {
        n[e] = this.shape[e];
      } else {
        let t = this.shape[e];
        while (t instanceof Tn) {
          t = t._def.innerType;
        }
        n[e] = t;
      }
    }
    return new e({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return bn(B.objectKeys(this.shape));
  }
};
Q.create = (e, t) => new Q({
  shape: () => e,
  unknownKeys: `strip`,
  catchall: rn.create(),
  typeName: $.ZodObject,
  ...X(t)
});
Q.strictCreate = (e, t) => new Q({
  shape: () => e,
  unknownKeys: `strict`,
  catchall: rn.create(),
  typeName: $.ZodObject,
  ...X(t)
});
Q.lazycreate = (e, t) => new Q({
  shape: e,
  unknownKeys: `strip`,
  catchall: rn.create(),
  typeName: $.ZodObject,
  ...X(t)
});
var cn = class extends Z {
  _parse(e) {
    let {
      ctx: t
    } = this._processInputParams(e);
    let n = this._def.options;
    function r(e) {
      for (let t of e) {
        if (t.result.status === `valid`) {
          return t.result;
        }
      }
      for (let n of e) {
        if (n.result.status === `dirty`) {
          t.common.issues.push(...n.ctx.common.issues);
          return n.result;
        }
      }
      let n = e.map(e => new U(e.ctx.common.issues));
      W(t, {
        code: H.invalid_union,
        unionErrors: n
      });
      return K;
    }
    if (t.common.async) {
      return Promise.all(n.map(async e => {
        let n = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await e._parseAsync({
            data: t.data,
            path: t.path,
            parent: n
          }),
          ctx: n
        };
      })).then(r);
    }
    {
      let e;
      let r = [];
      for (let i of n) {
        let n = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        let a = i._parseSync({
          data: t.data,
          path: t.path,
          parent: n
        });
        if (a.status === `valid`) {
          return a;
        }
        if (a.status === `dirty` && !e) {
          e = {
            result: a,
            ctx: n
          };
        }
        if (n.common.issues.length) {
          r.push(n.common.issues);
        }
      }
      if (e) {
        t.common.issues.push(...e.ctx.common.issues);
        return e.result;
      }
      let i = r.map(e => new U(e));
      W(t, {
        code: H.invalid_union,
        unionErrors: i
      });
      return K;
    }
  }
  get options() {
    return this._def.options;
  }
};
cn.create = (e, t) => new cn({
  options: e,
  typeName: $.ZodUnion,
  ...X(t)
});
var ln = e => e instanceof vn ? ln(e.schema) : e instanceof wn ? ln(e.innerType()) : e instanceof yn ? [e.value] : e instanceof xn ? e.options : e instanceof Sn ? B.objectValues(e.enum) : e instanceof Dn ? ln(e._def.innerType) : e instanceof $t ? [undefined] : e instanceof en ? [null] : e instanceof Tn ? [undefined, ...ln(e.unwrap())] : e instanceof En ? [null, ...ln(e.unwrap())] : e instanceof An || e instanceof Mn ? ln(e.unwrap()) : e instanceof On ? ln(e._def.innerType) : [];
var un = class e extends Z {
  _parse(e) {
    let {
      ctx: t
    } = this._processInputParams(e);
    if (t.parsedType !== V.object) {
      W(t, {
        code: H.invalid_type,
        expected: V.object,
        received: t.parsedType
      });
      return K;
    }
    let n = this.discriminator;
    let r = t.data[n];
    let i = this.optionsMap.get(r);
    if (i) {
      if (t.common.async) {
        return i._parseAsync({
          data: t.data,
          path: t.path,
          parent: t
        });
      } else {
        return i._parseSync({
          data: t.data,
          path: t.path,
          parent: t
        });
      }
    } else {
      W(t, {
        code: H.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [n]
      });
      return K;
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  static create(t, n, r) {
    let i = new Map();
    for (let e of n) {
      let n = ln(e.shape[t]);
      if (!n.length) {
        throw Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      }
      for (let r of n) {
        if (i.has(r)) {
          throw Error(`Discriminator property ${String(t)} has duplicate value ${String(r)}`);
        }
        i.set(r, e);
      }
    }
    return new e({
      typeName: $.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: i,
      ...X(r)
    });
  }
};
function dn(e, t) {
  let n = dt(e);
  let r = dt(t);
  if (e === t) {
    return {
      valid: true,
      data: e
    };
  }
  if (n === V.object && r === V.object) {
    let n = B.objectKeys(t);
    let r = B.objectKeys(e).filter(e => n.indexOf(e) !== -1);
    let i = {
      ...e,
      ...t
    };
    for (let n of r) {
      let r = dn(e[n], t[n]);
      if (!r.valid) {
        return {
          valid: false
        };
      }
      i[n] = r.data;
    }
    return {
      valid: true,
      data: i
    };
  }
  if (n === V.array && r === V.array) {
    if (e.length !== t.length) {
      return {
        valid: false
      };
    }
    let n = [];
    for (let r = 0; r < e.length; r++) {
      let i = e[r];
      let a = t[r];
      let o = dn(i, a);
      if (!o.valid) {
        return {
          valid: false
        };
      }
      n.push(o.data);
    }
    return {
      valid: true,
      data: n
    };
  }
  if (n === V.date && r === V.date && +e == +t) {
    return {
      valid: true,
      data: e
    };
  } else {
    return {
      valid: false
    };
  }
}
var fn = class extends Z {
  _parse(e) {
    let {
      status: t,
      ctx: n
    } = this._processInputParams(e);
    let r = (e, r) => {
      if (_t(e) || _t(r)) {
        return K;
      }
      let i = dn(e.value, r.value);
      if (i.valid) {
        if (vt(e) || vt(r)) {
          t.dirty();
        }
        return {
          status: t.value,
          value: i.data
        };
      } else {
        W(n, {
          code: H.invalid_intersection_types
        });
        return K;
      }
    };
    if (n.common.async) {
      return Promise.all([this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }), this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })]).then(([e, t]) => r(e, t));
    } else {
      return r(this._def.left._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      }), this._def.right._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      }));
    }
  }
};
fn.create = (e, t, n) => new fn({
  left: e,
  right: t,
  typeName: $.ZodIntersection,
  ...X(n)
});
var pn = class e extends Z {
  _parse(e) {
    let {
      status: t,
      ctx: n
    } = this._processInputParams(e);
    if (n.parsedType !== V.array) {
      W(n, {
        code: H.invalid_type,
        expected: V.array,
        received: n.parsedType
      });
      return K;
    }
    if (n.data.length < this._def.items.length) {
      W(n, {
        code: H.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: `array`
      });
      return K;
    }
    if (!this._def.rest && n.data.length > this._def.items.length) {
      W(n, {
        code: H.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: `array`
      });
      t.dirty();
    }
    let r = [...n.data].map((e, t) => {
      let r = this._def.items[t] || this._def.rest;
      if (r) {
        return r._parse(new Y(n, e, n.path, t));
      } else {
        return null;
      }
    }).filter(e => !!e);
    if (n.common.async) {
      return Promise.all(r).then(e => G.mergeArray(t, e));
    } else {
      return G.mergeArray(t, r);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new e({
      ...this._def,
      rest: t
    });
  }
};
pn.create = (e, t) => {
  if (!Array.isArray(e)) {
    throw Error(`You must pass an array of schemas to z.tuple([ ... ])`);
  }
  return new pn({
    items: e,
    typeName: $.ZodTuple,
    rest: null,
    ...X(t)
  });
};
var mn = class e extends Z {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    let {
      status: t,
      ctx: n
    } = this._processInputParams(e);
    if (n.parsedType !== V.object) {
      W(n, {
        code: H.invalid_type,
        expected: V.object,
        received: n.parsedType
      });
      return K;
    }
    let r = [];
    let i = this._def.keyType;
    let a = this._def.valueType;
    for (let e in n.data) {
      r.push({
        key: i._parse(new Y(n, e, n.path, e)),
        value: a._parse(new Y(n, n.data[e], n.path, e)),
        alwaysSet: e in n.data
      });
    }
    if (n.common.async) {
      return G.mergeObjectAsync(t, r);
    } else {
      return G.mergeObjectSync(t, r);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    if (n instanceof Z) {
      return new e({
        keyType: t,
        valueType: n,
        typeName: $.ZodRecord,
        ...X(r)
      });
    } else {
      return new e({
        keyType: Kt.create(),
        valueType: t,
        typeName: $.ZodRecord,
        ...X(n)
      });
    }
  }
};
var hn = class extends Z {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    let {
      status: t,
      ctx: n
    } = this._processInputParams(e);
    if (n.parsedType !== V.map) {
      W(n, {
        code: H.invalid_type,
        expected: V.map,
        received: n.parsedType
      });
      return K;
    }
    let r = this._def.keyType;
    let i = this._def.valueType;
    let a = [...n.data.entries()].map(([e, t], a) => ({
      key: r._parse(new Y(n, e, n.path, [a, `key`])),
      value: i._parse(new Y(n, t, n.path, [a, `value`]))
    }));
    if (n.common.async) {
      let e = new Map();
      return Promise.resolve().then(async () => {
        for (let n of a) {
          let r = await n.key;
          let i = await n.value;
          if (r.status === `aborted` || i.status === `aborted`) {
            return K;
          }
          if (r.status === `dirty` || i.status === `dirty`) {
            t.dirty();
          }
          e.set(r.value, i.value);
        }
        return {
          status: t.value,
          value: e
        };
      });
    }
    {
      let e = new Map();
      for (let n of a) {
        let r = n.key;
        let i = n.value;
        if (r.status === `aborted` || i.status === `aborted`) {
          return K;
        }
        if (r.status === `dirty` || i.status === `dirty`) {
          t.dirty();
        }
        e.set(r.value, i.value);
      }
      return {
        status: t.value,
        value: e
      };
    }
  }
};
hn.create = (e, t, n) => new hn({
  valueType: t,
  keyType: e,
  typeName: $.ZodMap,
  ...X(n)
});
var gn = class e extends Z {
  _parse(e) {
    let {
      status: t,
      ctx: n
    } = this._processInputParams(e);
    if (n.parsedType !== V.set) {
      W(n, {
        code: H.invalid_type,
        expected: V.set,
        received: n.parsedType
      });
      return K;
    }
    let r = this._def;
    if (r.minSize !== null && n.data.size < r.minSize.value) {
      W(n, {
        code: H.too_small,
        minimum: r.minSize.value,
        type: `set`,
        inclusive: true,
        exact: false,
        message: r.minSize.message
      });
      t.dirty();
    }
    if (r.maxSize !== null && n.data.size > r.maxSize.value) {
      W(n, {
        code: H.too_big,
        maximum: r.maxSize.value,
        type: `set`,
        inclusive: true,
        exact: false,
        message: r.maxSize.message
      });
      t.dirty();
    }
    let i = this._def.valueType;
    function a(e) {
      let n = new Set();
      for (let r of e) {
        if (r.status === `aborted`) {
          return K;
        }
        if (r.status === `dirty`) {
          t.dirty();
        }
        n.add(r.value);
      }
      return {
        status: t.value,
        value: n
      };
    }
    let o = [...n.data.values()].map((e, t) => i._parse(new Y(n, e, n.path, t)));
    if (n.common.async) {
      return Promise.all(o).then(e => a(e));
    } else {
      return a(o);
    }
  }
  min(t, n) {
    return new e({
      ...this._def,
      minSize: {
        value: t,
        message: J.toString(n)
      }
    });
  }
  max(t, n) {
    return new e({
      ...this._def,
      maxSize: {
        value: t,
        message: J.toString(n)
      }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
gn.create = (e, t) => new gn({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: $.ZodSet,
  ...X(t)
});
var _n = class e extends Z {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(e) {
    let {
      ctx: t
    } = this._processInputParams(e);
    if (t.parsedType !== V.function) {
      W(t, {
        code: H.invalid_type,
        expected: V.function,
        received: t.parsedType
      });
      return K;
    }
    function n(e, n) {
      return ht({
        data: e,
        path: t.path,
        errorMaps: [t.common.contextualErrorMap, t.schemaErrorMap, mt(), ft].filter(e => e),
        issueData: {
          code: H.invalid_arguments,
          argumentsError: n
        }
      });
    }
    function r(e, n) {
      return ht({
        data: e,
        path: t.path,
        errorMaps: [t.common.contextualErrorMap, t.schemaErrorMap, mt(), ft].filter(e => e),
        issueData: {
          code: H.invalid_return_type,
          returnTypeError: n
        }
      });
    }
    let i = {
      errorMap: t.common.contextualErrorMap
    };
    let a = t.data;
    if (this._def.returns instanceof Cn) {
      let e = this;
      return q(async function (...t) {
        let o = new U([]);
        let s = await e._def.args.parseAsync(t, i).catch(e => {
          o.addIssue(n(t, e));
          throw o;
        });
        let c = await Reflect.apply(a, this, s);
        return await e._def.returns._def.type.parseAsync(c, i).catch(e => {
          o.addIssue(r(c, e));
          throw o;
        });
      });
    }
    {
      let e = this;
      return q(function (...t) {
        let o = e._def.args.safeParse(t, i);
        if (!o.success) {
          throw new U([n(t, o.error)]);
        }
        let s = Reflect.apply(a, this, o.data);
        let c = e._def.returns.safeParse(s, i);
        if (!c.success) {
          throw new U([r(s, c.error)]);
        }
        return c.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new e({
      ...this._def,
      args: pn.create(t).rest(nn.create())
    });
  }
  returns(t) {
    return new e({
      ...this._def,
      returns: t
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(t, n, r) {
    return new e({
      args: t || pn.create([]).rest(nn.create()),
      returns: n || nn.create(),
      typeName: $.ZodFunction,
      ...X(r)
    });
  }
};
var vn = class extends Z {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    let {
      ctx: t
    } = this._processInputParams(e);
    return this._def.getter()._parse({
      data: t.data,
      path: t.path,
      parent: t
    });
  }
};
vn.create = (e, t) => new vn({
  getter: e,
  typeName: $.ZodLazy,
  ...X(t)
});
var yn = class extends Z {
  _parse(e) {
    if (e.data !== this._def.value) {
      let t = this._getOrReturnCtx(e);
      W(t, {
        received: t.data,
        code: H.invalid_literal,
        expected: this._def.value
      });
      return K;
    }
    return {
      status: `valid`,
      value: e.data
    };
  }
  get value() {
    return this._def.value;
  }
};
yn.create = (e, t) => new yn({
  value: e,
  typeName: $.ZodLiteral,
  ...X(t)
});
function bn(e, t) {
  return new xn({
    values: e,
    typeName: $.ZodEnum,
    ...X(t)
  });
}
var xn = class e extends Z {
  _parse(e) {
    if (typeof e.data != `string`) {
      let t = this._getOrReturnCtx(e);
      let n = this._def.values;
      W(t, {
        expected: B.joinValues(n),
        received: t.parsedType,
        code: H.invalid_type
      });
      return K;
    }
    this._cache ||= new Set(this._def.values);
    if (!this._cache.has(e.data)) {
      let t = this._getOrReturnCtx(e);
      let n = this._def.values;
      W(t, {
        received: t.data,
        code: H.invalid_enum_value,
        options: n
      });
      return K;
    }
    return q(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    let e = {};
    for (let t of this._def.values) {
      e[t] = t;
    }
    return e;
  }
  get Values() {
    let e = {};
    for (let t of this._def.values) {
      e[t] = t;
    }
    return e;
  }
  get Enum() {
    let e = {};
    for (let t of this._def.values) {
      e[t] = t;
    }
    return e;
  }
  extract(t, n = this._def) {
    return e.create(t, {
      ...this._def,
      ...n
    });
  }
  exclude(t, n = this._def) {
    return e.create(this.options.filter(e => !t.includes(e)), {
      ...this._def,
      ...n
    });
  }
};
xn.create = bn;
var Sn = class extends Z {
  _parse(e) {
    let t = B.getValidEnumValues(this._def.values);
    let n = this._getOrReturnCtx(e);
    if (n.parsedType !== V.string && n.parsedType !== V.number) {
      let e = B.objectValues(t);
      W(n, {
        expected: B.joinValues(e),
        received: n.parsedType,
        code: H.invalid_type
      });
      return K;
    }
    this._cache ||= new Set(B.getValidEnumValues(this._def.values));
    if (!this._cache.has(e.data)) {
      let e = B.objectValues(t);
      W(n, {
        received: n.data,
        code: H.invalid_enum_value,
        options: e
      });
      return K;
    }
    return q(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
Sn.create = (e, t) => new Sn({
  values: e,
  typeName: $.ZodNativeEnum,
  ...X(t)
});
var Cn = class extends Z {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    let {
      ctx: t
    } = this._processInputParams(e);
    if (t.parsedType !== V.promise && t.common.async === false) {
      W(t, {
        code: H.invalid_type,
        expected: V.promise,
        received: t.parsedType
      });
      return K;
    } else {
      return q((t.parsedType === V.promise ? t.data : Promise.resolve(t.data)).then(e => this._def.type.parseAsync(e, {
        path: t.path,
        errorMap: t.common.contextualErrorMap
      })));
    }
  }
};
Cn.create = (e, t) => new Cn({
  type: e,
  typeName: $.ZodPromise,
  ...X(t)
});
var wn = class extends Z {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    if (this._def.schema._def.typeName === $.ZodEffects) {
      return this._def.schema.sourceType();
    } else {
      return this._def.schema;
    }
  }
  _parse(e) {
    let {
      status: t,
      ctx: n
    } = this._processInputParams(e);
    let r = this._def.effect || null;
    let i = {
      addIssue: e => {
        W(n, e);
        if (e.fatal) {
          t.abort();
        } else {
          t.dirty();
        }
      },
      get path() {
        return n.path;
      }
    };
    i.addIssue = i.addIssue.bind(i);
    if (r.type === `preprocess`) {
      let e = r.transform(n.data, i);
      if (n.common.async) {
        return Promise.resolve(e).then(async e => {
          if (t.value === `aborted`) {
            return K;
          }
          let r = await this._def.schema._parseAsync({
            data: e,
            path: n.path,
            parent: n
          });
          if (r.status === `aborted`) {
            return K;
          } else if (r.status === `dirty` || t.value === `dirty`) {
            return gt(r.value);
          } else {
            return r;
          }
        });
      }
      {
        if (t.value === `aborted`) {
          return K;
        }
        let r = this._def.schema._parseSync({
          data: e,
          path: n.path,
          parent: n
        });
        if (r.status === `aborted`) {
          return K;
        } else if (r.status === `dirty` || t.value === `dirty`) {
          return gt(r.value);
        } else {
          return r;
        }
      }
    }
    if (r.type === `refinement`) {
      let e = e => {
        let t = r.refinement(e, i);
        if (n.common.async) {
          return Promise.resolve(t);
        }
        if (t instanceof Promise) {
          throw Error(`Async refinement encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return e;
      };
      if (n.common.async === false) {
        let r = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (r.status === `aborted`) {
          return K;
        } else {
          if (r.status === `dirty`) {
            t.dirty();
          }
          e(r.value);
          return {
            status: t.value,
            value: r.value
          };
        }
      }
      return this._def.schema._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }).then(n => n.status === `aborted` ? K : (n.status === `dirty` && t.dirty(), e(n.value).then(() => ({
        status: t.value,
        value: n.value
      }))));
    }
    if (r.type === `transform`) {
      if (n.common.async === false) {
        let e = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!yt(e)) {
          return K;
        }
        let a = r.transform(e.value, i);
        if (a instanceof Promise) {
          throw Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return {
          status: t.value,
          value: a
        };
      }
      return this._def.schema._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }).then(e => yt(e) ? Promise.resolve(r.transform(e.value, i)).then(e => ({
        status: t.value,
        value: e
      })) : K);
    }
    B.assertNever(r);
  }
};
wn.create = (e, t, n) => new wn({
  schema: e,
  typeName: $.ZodEffects,
  effect: t,
  ...X(n)
});
wn.createWithPreprocess = (e, t, n) => new wn({
  schema: t,
  effect: {
    type: `preprocess`,
    transform: e
  },
  typeName: $.ZodEffects,
  ...X(n)
});
var Tn = class extends Z {
  _parse(e) {
    if (this._getType(e) === V.undefined) {
      return q(undefined);
    } else {
      return this._def.innerType._parse(e);
    }
  }
  unwrap() {
    return this._def.innerType;
  }
};
Tn.create = (e, t) => new Tn({
  innerType: e,
  typeName: $.ZodOptional,
  ...X(t)
});
var En = class extends Z {
  _parse(e) {
    if (this._getType(e) === V.null) {
      return q(null);
    } else {
      return this._def.innerType._parse(e);
    }
  }
  unwrap() {
    return this._def.innerType;
  }
};
En.create = (e, t) => new En({
  innerType: e,
  typeName: $.ZodNullable,
  ...X(t)
});
var Dn = class extends Z {
  _parse(e) {
    let {
      ctx: t
    } = this._processInputParams(e);
    let n = t.data;
    if (t.parsedType === V.undefined) {
      n = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data: n,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
Dn.create = (e, t) => new Dn({
  innerType: e,
  typeName: $.ZodDefault,
  defaultValue: typeof t.default == `function` ? t.default : () => t.default,
  ...X(t)
});
var On = class extends Z {
  _parse(e) {
    let {
      ctx: t
    } = this._processInputParams(e);
    let n = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    };
    let r = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    if (bt(r)) {
      return r.then(e => ({
        status: `valid`,
        value: e.status === `valid` ? e.value : this._def.catchValue({
          get error() {
            return new U(n.common.issues);
          },
          input: n.data
        })
      }));
    } else {
      return {
        status: `valid`,
        value: r.status === `valid` ? r.value : this._def.catchValue({
          get error() {
            return new U(n.common.issues);
          },
          input: n.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
};
On.create = (e, t) => new On({
  innerType: e,
  typeName: $.ZodCatch,
  catchValue: typeof t.catch == `function` ? t.catch : () => t.catch,
  ...X(t)
});
var kn = class extends Z {
  _parse(e) {
    if (this._getType(e) !== V.nan) {
      let t = this._getOrReturnCtx(e);
      W(t, {
        code: H.invalid_type,
        expected: V.nan,
        received: t.parsedType
      });
      return K;
    }
    return {
      status: `valid`,
      value: e.data
    };
  }
};
kn.create = e => new kn({
  typeName: $.ZodNaN,
  ...X(e)
});
var An = class extends Z {
  _parse(e) {
    let {
      ctx: t
    } = this._processInputParams(e);
    let n = t.data;
    return this._def.type._parse({
      data: n,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
};
var jn = class e extends Z {
  _parse(e) {
    let {
      status: t,
      ctx: n
    } = this._processInputParams(e);
    if (n.common.async) {
      return (async () => {
        let e = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (e.status === `aborted`) {
          return K;
        } else if (e.status === `dirty`) {
          t.dirty();
          return gt(e.value);
        } else {
          return this._def.out._parseAsync({
            data: e.value,
            path: n.path,
            parent: n
          });
        }
      })();
    }
    {
      let e = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      if (e.status === `aborted`) {
        return K;
      } else if (e.status === `dirty`) {
        t.dirty();
        return {
          status: `dirty`,
          value: e.value
        };
      } else {
        return this._def.out._parseSync({
          data: e.value,
          path: n.path,
          parent: n
        });
      }
    }
  }
  static create(t, n) {
    return new e({
      in: t,
      out: n,
      typeName: $.ZodPipeline
    });
  }
};
var Mn = class extends Z {
  _parse(e) {
    let t = this._def.innerType._parse(e);
    let n = e => {
      if (yt(e)) {
        e.value = Object.freeze(e.value);
      }
      return e;
    };
    if (bt(t)) {
      return t.then(e => n(e));
    } else {
      return n(t);
    }
  }
  unwrap() {
    return this._def.innerType;
  }
};
Mn.create = (e, t) => new Mn({
  innerType: e,
  typeName: $.ZodReadonly,
  ...X(t)
});
Q.lazycreate;
var $;
(function (e) {
  e.ZodString = `ZodString`;
  e.ZodNumber = `ZodNumber`;
  e.ZodNaN = `ZodNaN`;
  e.ZodBigInt = `ZodBigInt`;
  e.ZodBoolean = `ZodBoolean`;
  e.ZodDate = `ZodDate`;
  e.ZodSymbol = `ZodSymbol`;
  e.ZodUndefined = `ZodUndefined`;
  e.ZodNull = `ZodNull`;
  e.ZodAny = `ZodAny`;
  e.ZodUnknown = `ZodUnknown`;
  e.ZodNever = `ZodNever`;
  e.ZodVoid = `ZodVoid`;
  e.ZodArray = `ZodArray`;
  e.ZodObject = `ZodObject`;
  e.ZodUnion = `ZodUnion`;
  e.ZodDiscriminatedUnion = `ZodDiscriminatedUnion`;
  e.ZodIntersection = `ZodIntersection`;
  e.ZodTuple = `ZodTuple`;
  e.ZodRecord = `ZodRecord`;
  e.ZodMap = `ZodMap`;
  e.ZodSet = `ZodSet`;
  e.ZodFunction = `ZodFunction`;
  e.ZodLazy = `ZodLazy`;
  e.ZodLiteral = `ZodLiteral`;
  e.ZodEnum = `ZodEnum`;
  e.ZodEffects = `ZodEffects`;
  e.ZodNativeEnum = `ZodNativeEnum`;
  e.ZodOptional = `ZodOptional`;
  e.ZodNullable = `ZodNullable`;
  e.ZodDefault = `ZodDefault`;
  e.ZodCatch = `ZodCatch`;
  e.ZodPromise = `ZodPromise`;
  e.ZodBranded = `ZodBranded`;
  e.ZodPipeline = `ZodPipeline`;
  e.ZodReadonly = `ZodReadonly`;
})($ ||= {});
var Nn = Kt.create;
var Pn = Jt.create;
kn.create;
Yt.create;
var Fn = Xt.create;
Zt.create;
Qt.create;
$t.create;
en.create;
tn.create;
nn.create;
rn.create;
an.create;
on.create;
var In = Q.create;
Q.strictCreate;
var Ln = cn.create;
un.create;
fn.create;
pn.create;
mn.create;
hn.create;
gn.create;
_n.create;
vn.create;
var Rn = yn.create;
var zn = xn.create;
Sn.create;
Cn.create;
wn.create;
Tn.create;
En.create;
wn.createWithPreprocess;
jn.create;
export { In as a, lt as c, Pn as i, nt as l, zn as n, Nn as o, Rn as r, Ln as s, Fn as t, r as u };